<template>
  <div class="container my-1">
    <div v-if="exibirSomenteAviso">
      <!-- <b-card class="mt-5">         -->
      <b-alert class="mt-5" show variant="warning">
        <h4 class="alert-heading"><b>ATENÇÃO !</b></h4>
        <hr />
        <p>
          <b>
            INFORMAMOS QUE, NO PERÍODO DE {{ periodoInterrupcao }}, O CADASTRO
            DO IPTU ESTARÁ FECHADO PARA O LANÇAMENTO DO IPTU/{{ anoIPTU }}. O
            SERVIÇO EM QUESTÃO SERÁ DISPONIBILIZADO NOVAMENTE A PARTIR DO DIA
            {{ dataLiberadaInterrupcao }}.
          </b>
        </p>
      </b-alert>
      <!-- </b-card>    -->
    </div>
    <div v-else>
      <div :v-if="mensagemSucesso" v-for="i in mensagemSucesso" :key="i">
        <p>
          <b-alert show variant="success" dismissible>{{ i }}</b-alert>
        </p>
      </div>
      <div :v-if="mensagemErro" v-for="i in mensagemErro" :key="i">
        <p>
          <b-alert show variant="danger" dismissible>
            <b-icon variant="danger" icon="x-circle-fill" />
            {{ i }}
          </b-alert>
        </p>
      </div>
      <div v-if="mostrarMensagemDebitosInexistentes" class="pb-1">
        <p>
          <b-alert show variant="warning" dismissible>
            <b-icon variant="warning" icon="exclamation-diamond-fill" />
            Não existe(m) débito(s) para esta pesquisa. Solicite a CND (certidão
            negativa de débitos) clicando
            <a
              href="http://cndonline.siatu.pbh.gov.br/CNDOnline"
              target="_blank"
              >aqui</a
            >.
          </b-alert>
        </p>
      </div>
      <p></p>
      <div>
        <div style="text-align: center">
          <loading :active.sync="carregando" :is-full-page="true"></loading>
        </div>
        <div class="mt-0">
          <!-- ABA DADOS GERAIS -->
          <form @submit.prevent>
            <h2 class="title">Alteração de Endereço de Imóvel</h2>
            <b-card>
              <span
                class="title h5"
                v-b-tooltip.hover="{ variant: 'primary', placement: 'right' }"
                title="Índice cadastral do imóvel"
              >
                Índice cadastral do imóvel
                <b-icon
                  variant="primary"
                  icon="info-circle-fill"
                  class="ml-2"
                />
              </span>

              <b-row class="my-3">
                <b-col sm="3" md="3"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="indice" class="pb-3">Índice Cadastral</label>
                </b-col>
                <b-col sm="6" md="4" align-self="start">
                  <b-form-input
                    id="indiceCadastral"
                    class="ml-3"
                    v-mask="mascaraIdentificador"
                    type="search"
                    @keydown="validacaoIndiceCadastral()"
                    v-model="informacaoContribuinte.indiceCadastral"
                    :disabled="bloquearIndiceCadastral"
                  >
                  </b-form-input>
                  <small id="iptu" :class="erroValidacaoIptu" class="ml-3">
                    {{ mensagemValidacaoIptu }}
                  </small>
                </b-col>
              </b-row>

              <b-row class="mb-0 float-right">
                <b-button
                  variant="secondary"
                  class="float-right"
                  @click="() => limparTudo()"
                >
                  Limpar
                </b-button>
                <b-button
                  variant="primary"
                  class="ml-3 mr-3 float-right"
                  :disabled="!preencheIptuOK"
                  @click.prevent="() => pesquisar()"
                >
                  Pesquisar
                </b-button>
              </b-row>
            </b-card>
          </form>
        </div>
        <!--  -->
        <div v-if="this.mostrarEnderecoImovel && !carregando" class="my-1">
          <h2 class="title mt-5"></h2>
          <b-card class="mb-5">
            <span class="title h5"> Endereço de imóvel atual </span>
            <br /><br />
            <b-card class="bg-success mx-5">
              <div style="text-align: center">
                <span class="text-white font-weight-bolder">
                  {{ imovel.ENDERECO_LOCALIZACAO }}</span
                >
              </div>
            </b-card>
            <br />
            <div style="text-align: right">
              <b-button
                variant="primary"
                class="ml-3 mr-3 float-right"
                @click.prevent="() => buscarListaLoteCTMPorIndiceCadastral()"
              >
                Alterar
              </b-button>
            </div>
          </b-card>
        </div>

        <div v-if="this.mostrarListaOpcoes && !carregando" class="my-1">
          <h2 class="title mt-5"></h2>
          <b-card>
            <div v-if="origemAcesso === 'AD' || origemAcesso === 'GovBr'">
              <span class="title h5"> Lista de opções </span>

              <b-row class="my-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="cep" class="pb-3"></label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-radio-group
                    v-model="opcaoLoteCTM"
                    :options="listaLoteCTM"
                    class="mb-3"
                  ></b-form-radio-group>
                </b-col>
              </b-row>

              <br />
              <div style="text-align: right">
                <b-button
                  variant="primary"
                  class="ml-3 mr-3 float-right"
                  @click.prevent="() => gravarEnderecoImovel()"
                >
                  Gravar
                </b-button>
              </div>
            </div>
          </b-card>
        </div>

        <div
          v-if="this.mostrarEnderecoCorrespondencia && !carregando"
          class="my-1"
        >
          <h2 class="title mt-5"></h2>
          <b-card>
            <div v-if="origemAcesso === 'AD' || origemAcesso === 'GovBr'">
              <span class="title h5"> Novo endereço de correspondência </span>

              <b-row class="my-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="cep" class="pb-3">CEP</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input
                    id="cep"
                    class="ml-3"
                    v-model="endereco.cep"
                    v-mask="['##.###-###']"
                    :disabled="bloquearCepNumero"
                  >
                  </b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-3">
                <b-col sm="2" md="2"> </b-col>
                <b-col sm="2" md="2" lg="1" align-self="center">
                  <label for="numero" class="pb-3">Numero</label>
                </b-col>
                <b-col sm="8" md="4" align-self="start">
                  <b-form-input
                    id="numero"
                    class="ml-3"
                    v-mask="['######']"
                    v-model="endereco.numero"
                    :disabled="bloquearCepNumero"
                  >
                  </b-form-input>
                </b-col>
              </b-row>

              <div v-if="this.mostrarDemaisCamposEndereco && !carregando">
                <b-row class="my-3">
                  <b-col sm="2" md="2"> </b-col>
                  <b-col sm="2" md="2" lg="1" align-self="center">
                    <label for="logradouro" class="pb-3">Logradouro</label>
                  </b-col>
                  <b-col sm="8" md="4" align-self="start">
                    <b-form-input
                      id="logradouro"
                      class="ml-3"
                      v-model="endereco.logradouro"
                      :maxlength="60"
                      :disabled="bloquearLogradouroBairro"
                    >
                    </b-form-input>
                  </b-col>
                </b-row>

                <b-row class="my-3">
                  <b-col sm="2" md="2"> </b-col>
                  <b-col sm="2" md="2" lg="1" align-self="center">
                    <label for="bairro" class="pb-3">Bairro</label>
                  </b-col>
                  <b-col sm="8" md="4" align-self="start">
                    <b-form-input
                      id="bairro"
                      class="ml-3"
                      v-model="endereco.bairro"
                      :maxlength="60"
                      :disabled="bloquearLogradouroBairro"
                    >
                    </b-form-input>
                  </b-col>
                </b-row>

                <b-row class="my-3">
                  <b-col sm="2" md="2"> </b-col>
                  <b-col sm="2" md="2" lg="1" align-self="center">
                    <label for="cidade" class="pb-3">Cidade</label>
                  </b-col>
                  <b-col sm="8" md="4" align-self="start">
                    <b-form-input
                      id="cidade"
                      class="ml-3"
                      v-model="endereco.municipio"
                      :maxlength="60"
                      :disabled="true"
                    >
                    </b-form-input>
                  </b-col>
                </b-row>

                <b-row class="my-3">
                  <b-col sm="2" md="2"> </b-col>
                  <b-col sm="2" md="2" lg="1" align-self="center">
                    <label for="estado" class="pb-3">Estado</label>
                  </b-col>
                  <b-col sm="8" md="4" align-self="start">
                    <b-form-input
                      id="estado"
                      class="ml-3"
                      v-model="endereco.estado"
                      :maxlength="2"
                      :disabled="true"
                    >
                    </b-form-input>
                  </b-col>
                </b-row>

                <b-row class="my-3">
                  <b-col sm="2" md="2"> </b-col>
                  <b-col sm="2" md="2" lg="1" align-self="center"> </b-col>
                  <b-col>
                    <table
                      aligm="center"
                      summary="Tabela de Complemento de Endereço"
                    >
                      <th>
                        <td align="center">
                          <h6>Tipos de Complemento</h6>
                        </td>
                        <td></td>
                        <td align="center">
                          <h6>Complementos</h6>
                        </td>
                      </th>
                      <tr>
                        <td>
                          <div style="width: 300px" align="center">
                            <b-form-select
                              id="tipoComplemento1"
                              class="ml-3 mb-0 mr-sm-2 mb-sm-0"
                              v-model="tipoComplemento1"
                              :options="listaTiposComplemento"
                            >
                            </b-form-select>
                          </div>
                        </td>
                        <td></td>
                        <td>
                          <b-form-input
                            id="complemento1"
                            class="ml-3"
                            v-model="complemento1"
                            :maxlength="25"
                          >
                          </b-form-input>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b-form-select
                            id="tipoComplemento2"
                            class="ml-3 mb-0 mr-sm-2 mb-sm-0"
                            v-model="tipoComplemento2"
                            :options="listaTiposComplemento"
                          >
                          </b-form-select>
                        </td>
                        <td></td>
                        <td>
                          <b-form-input
                            id="complemento2"
                            class="ml-3"
                            v-model="complemento2"
                            :maxlength="25"
                          >
                          </b-form-input>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b-form-select
                            id="tipoComplemento3"
                            class="ml-3 mb-0 mr-sm-2 mb-sm-0"
                            v-model="tipoComplemento3"
                            :options="listaTiposComplemento"
                          >
                          </b-form-select>
                        </td>
                        <td></td>
                        <td>
                          <b-form-input
                            id="complemento3"
                            class="ml-3"
                            v-model="complemento3"
                            :maxlength="25"
                          >
                          </b-form-input>
                        </td>
                      </tr>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </div>

            <b-row class="mb-0 float-right">
              <b-col v-if="!this.mostrarDemaisCamposEndereco">
                <b-button
                  variant="primary"
                  class="ml-3 mr-3 float-right"
                  @click.prevent="() => pesquisarEnderecoPorCepNumero()"
                >
                  Pesquisar
                </b-button>
              </b-col>
              <b-col v-else>
                <b-button
                  variant="primary"
                  class="ml-3 mr-3 float-right"
                  @click.prevent="() => gravarEndereco()"
                >
                  Gravar
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <!--  -->
        <div class="mt-5" v-else>
          <div
            :v-if="mensagemLancamentos"
            v-for="i in mensagemLancamentos"
            :key="i"
          >
            <p>
              <b-alert show variant="warning">
                <b-icon variant="warning" icon="exclamation-diamond-fill" />
                {{ i }}
              </b-alert>
            </p>
          </div>
        </div>

        <!-- lista guias a vista-->
        <div v-if="exibirListaGuia === true">
          <h2 class="title mt-5">Relação de DRAM para pagamento à vista</h2>
          <b-card class="mt-3">
            <tabelaGuiasVista :items="calculos" :fields="cabecalhoGuias" />
            <b-row class="mt-3 float-right">
              <b-button
                class="my-3 mr-4"
                variant="secondary"
                @click="fecharGuiasAVista()"
              >
                Opção de pagamento
              </b-button>
            </b-row>
          </b-card>
        </div>
        <!-- lista guias a vista -->

        <!-- lista guias parcelado -->
        <div v-if="exibirListaGuiaParcelar === true">
          <h2 class="title mt-5">Seleção de parcelas para cada tipo de DRAM</h2>
          <b-card class="mb-3">
            <tabelaListaParcelamento
              :items="listaParcelamentosCalc"
              :selecionados="selecLanctosParctoTacito"
              :desabilitaOpcoes="bloqueiaOpcao"
              v-on:parcelamentoTacito="getSelecionados($event)"
            />
          </b-card>
        </div>
        <!-- lista guias parcelado -->

        <b-card class="mt-3" v-if="calculos.RESUMO_CALCULO">
          <div>
            <div class="d-flex justify-content-around mt-3">
              <b-button
                class="mt-2 botao"
                variant="primary"
                size="lg"
                :disabled="bloqueioEmissaoGuia"
                @click.prevent="abrirDialogPagamentoAVista()"
              >
                Pagamento integral ou parcial
              </b-button>

              <b-button
                class="mt-2 botao"
                variant="secondary"
                :disabled="bloqueioEmissaoGuia"
                @click.prevent="abrirDialogParcelamento()"
              >
                Parcelar
              </b-button>

              <b-button
                class="mt-2"
                variant="secondary"
                @click.stop="simularPagamento"
              >
                Simulação
              </b-button>
            </div>
          </div>
        </b-card>

        <!-- lista parcelamento  -->
        <b-card class="mt-3" v-if="exibirParcelamento">
          <div>
            <p>Selecione a DRAM a ser emitida:</p>
            <b-row
              v-for="(guia, index) in listaGuiasParcelamento"
              :key="index"
              class="text-center mb-2"
              align-v="center"
            >
              <b-col>
                <b-button
                  :variant="
                    btnSelecionadosParcelamento.findIndex(
                      (e) => e.id === `${index}`
                    ) !== -1
                      ? 'danger'
                      : 'primary'
                  "
                  @click="guiaPagamentoAVista(guia.URLEMISSAO, index)"
                >
                  {{ guia.DESCRICAO }}
                  {{
                    btnSelecionadosParcelamento.findIndex(
                      (e) => e.id === `${index}`
                    ) !== -1
                      ? " ( ** DRAM emitida ** )"
                      : " ( Emitir DRAM )"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </div>

          <!-- <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAMs para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert
          >
        </div> -->
        </b-card>
        <!-- fim -->

        <b-modal
          ref="dialog-confirmar-selecao"
          hide-footer
          title="Confirmar"
          size="sm"
          modal-class="small-modal"
          centered
        >
          <p>
            Não foram selecionados todos os débitos do tipo "{{
              orgaoCobranca.DESCRICAO
            }}" para esta emissão. Você deseja prosseguir com esta seleção?
          </p>

          <b-button-group class="w-100">
            <b-button
              colspan="6"
              variant="outline-secondary "
              @click="fecharModal('dialog-confirmar-a-vista')"
              >Não</b-button
            >
            <b-button
              colspan="6"
              class="ml-3"
              variant="primary"
              @click="
                abrirModalPagamentoAVistaSeNecessario('modal-pagamento-a-vista')
              "
              >Sim</b-button
            >
          </b-button-group>
        </b-modal>

        <b-modal
          ref="modal-pagamento-a-vista"
          hide-footer
          title="Pagar à Vista"
          size="xl"
          modal-class="small-modal"
        >
          <div v-if="calculos.TLISTAURLGUIA">
            <p>Selecione a DRAM a ser emitida:</p>
            <b-row
              v-for="guia in calculos.TLISTAURLGUIA"
              :key="guia"
              class="text-center"
              align-v="center"
            >
              <b-col>
                <b-button
                  variant="primary"
                  @click="guiaPagamentoAVista(guia.URLEMISSAO)"
                >
                  {{ guia.DESCRICAO }}
                </b-button>
                <hr />
              </b-col>
            </b-row>
          </div>

          <div v-else>
            <b-alert show variant="danger">
              <b-icon variant="danger" icon="x-circle-fill" />
              Erro ao gerar os DRAMs para pagamento à vísta, favor verificar com
              o Administrator do sistema.</b-alert
            >
          </div>
        </b-modal>

        <!-- <b-modal
        ref="modal-guias-parcelamento"
        hide-footer
        title="Guias do parcelamento"
        size="xl"
        modal-class="small-modal"
      >
        <div v-if="listaGuiasParcelamento">
          <p>Selecione a guia a ser emitida:</p>
          <b-row
            v-for="guia in listaGuiasParcelamento"
            :key="guia"
            class="text-center"
            align-v="center"
          >
            <b-col>
              <b-button
                variant="primary"
                @click="guiaPagamentoAVista(guia.URLEMISSAO)"
              >
                {{ guia.DESCRICAO }}
              </b-button>
              <hr />
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-alert show variant="danger">
            <b-icon variant="danger" icon="x-circle-fill" />
            Erro ao gerar os DRAMs para pagamento à vísta, favor verificar com o
            Administrator do sistema.</b-alert
          >
        </div>
      </b-modal> -->

        <b-modal
          ref="modal-confirmar-parcelamento"
          hide-footer
          title="Seleção de Parcelamentos"
          size="xl"
          modal-class="small-modal"
        >
          <div
            v-if="
              calculos.OPCOES_PARCTO_CESSAO || calculos.OPCOES_PARCTO_DEMAIS
            "
          >
            <p>
              Para o parcelamento deverão ser emitidas dois DRAM, uma para cada
              opção abaixo:
            </p>
            <b-row class="text-center" align-v="center">
              <b-col v-if="calculos.OPCOES_PARCTO_CESSAO">
                <b-button
                  variant="primary"
                  @click="abrirModalParcelamentoSeNecessario('cessao')"
                >
                  DRAM de Lançamentos Cedidos
                </b-button>
              </b-col>

              <b-col v-if="calculos.OPCOES_PARCTO_DEMAIS">
                <b-button
                  variant="primary"
                  @click="abrirModalParcelamentoSeNecessario('demais')"
                >
                  DRAM Demais Lançamentos
                </b-button>
              </b-col>
            </b-row>
          </div>

          <div v-else>
            <b-alert show variant="danger">
              <b-icon variant="danger" icon="x-circle-fill" />
              Erro ao gerar os DRAM para pagamento à vísta, favor verificar com
              o Administrator do sistema.</b-alert
            >
          </div>
        </b-modal>

        <b-modal
          ref="modal-selecao-parcelamento"
          hide-footer
          title="Seleção de Parcelamentos"
          size="xl"
          modal-class="small-modal"
        >
          <div v-if="this.opcoesParcto">
            <p>Selecione uma das opções:</p>

            <b-row
              v-for="opcao in opcoesParcto"
              :key="opcao"
              class="text-center"
              align-v="center"
            >
              <b-col>
                <b-button
                  variant="primary"
                  @click="abrirModalParcelamento(opcao)"
                >
                  {{ opcao.DESCRICAO_GRUPO }}
                </b-button>
                <hr />
              </b-col>
            </b-row>
          </div>

          <div v-else>
            <b-alert show variant="danger">
              <b-icon variant="danger" icon="x-circle-fill" />
              Erro ao gerar os DRAM para pagamento à vísta, favor verificar com
              o Administrator do sistema.</b-alert
            >
          </div>
        </b-modal>

        <b-modal
          ref="modal-parcelamento"
          hide-footer
          title="Parcelamento"
          size="xl"
          @hide="limparCamposParcelamento()"
        >
          <div v-if="this.opcaoParctoSelecionada.LISTA_OPCAO_PARCTO">
            <p>Selecione abaixo uma das opções de parcelamento</p>
            <div class="mb-3">
              <h5>Opções de parcelamento</h5>
              <b-form-select
                id="opcoesParcelamentoInternas"
                v-model="escolhaOpcaoParcelamentoInterna"
                :options="listaOpcoesParcelamentoInternas"
              />
            </div>

            <h4 class="mt-5">Contato</h4>
            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="telefoneCelular">Telefone Celular</label>
              </b-col>
              <b-col sm="3" align-self="start">
                <b-form-input
                  id="telefoneCelular"
                  placeholder="(31)99999-9999"
                  v-mask="['(##)#####-####']"
                  v-model="informacaoParcelamento.telefone"
                >
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="2" align-self="end">
                <label for="email">Email</label>
              </b-col>
              <b-col sm="3" align-self="start">
                <b-form-input
                  type="email"
                  id="email"
                  placeholder="exemplo@exemplo.com.br"
                  v-model="informacaoParcelamento.email"
                >
                </b-form-input>
              </b-col>
            </b-row>

            <div class="float-right">
              <b-button
                variant="primary"
                :disabled="
                  escolhaOpcaoParcelamentoInterna === '' ||
                  (informacaoParcelamento.email.length < 6 &&
                    !informacaoParcelamento.email.includes('@') &&
                    informacaoParcelamento.telefone.length < 14)
                "
                @click.prevent="emitirGuiaParcelamento"
              >
                Emitir DRAM</b-button
              >
            </div>
          </div>
          <div v-else>
            <b-alert show variant="danger"
              ><b-icon variant="danger" icon="x-circle-fill" />Erro ao gerar os
              parcelamentos, favor verificar com o Administrator do
              sistema.</b-alert
            >
          </div>
        </b-modal>

        <b-modal
          ref="modal-EmissaoGuia"
          hide-footer
          title="Confirmar emissão de DRAMs"
          size="xl"
          @show="autenticarEmissao()"
          @hide="limparCamposEmissaoGuia()"
        >
          <div
            :v-if="mensagemEmissaoGuia"
            v-for="i in mensagemEmissaoGuia"
            :key="i"
          >
            <p>
              <b-alert show variant="danger" dismissible>
                <b-icon variant="danger" icon="x-circle-fill" />
                {{ i }}
              </b-alert>
            </p>
          </div>
          <div
            :v-if="mensagemEmissaoGuiaSucesso"
            v-for="i in mensagemEmissaoGuiaSucesso"
            :key="i"
          >
            <p>
              <b-alert show variant="success" dismissible>
                <b-icon variant="success" icon="check2" />
                {{ i }}
              </b-alert>
            </p>
          </div>

          <h5>Preencha os dados abaixo para confirmar a emissão</h5>

          <b-row class="my-3">
            <b-col sm="2" align-self="end">
              <label for="cadastroNacional">CPF/CNPJ</label
              ><span class="ml-1" style="color: red">*</span>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input
                id="cadastroNacional"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                @keydown="validacaoCPFCNPJ()"
                v-model="informacoesEmissaoGuia.cpfCnpj"
              >
              </b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="razaoSocial">Nome/Razão Social</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input
                id="razaoSocial"
                disabled="disabled"
                v-model="informacoesEmissaoGuia.razaoSocial"
              >
              </b-form-input>
            </b-col>
          </b-row>

          <h5>Contato</h5>
          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="telefone">Telefone Celular</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input
                id="telefone"
                v-mask="['(##)####-####', '(##)#####-####']"
                placeholder="(31)99999-9999"
                v-model="informacoesEmissaoGuia.telefoneCelular"
              >
              </b-form-input>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2" align-self="end">
              <label for="email">Email</label>
            </b-col>
            <b-col sm="3" align-self="start">
              <b-form-input
                id="email"
                type="email"
                v-model="informacoesEmissaoGuia.email"
                placeholder="exemplo@exemplo.com.br"
              >
              </b-form-input>
            </b-col>
          </b-row>

          <b-card
            v-if="
              informacoesEmissaoGuia.telefoneEnviado ||
              informacoesEmissaoGuia.emailEnviado
            "
            class="bg-secondary mt-5 mb-3 w-50 mx-auto"
          >
            <div style="text-align: center">
              <span class="font-weight-bolder text-white">
                Preencha o código recebido para confirmar a emissão
              </span>
              <b-form-input
                id="cancelarParcelamento"
                v-model="informacoesEmissaoGuia.codigoEmissaoGuia"
              />
            </div>
          </b-card>

          <div
            v-if="
              informacoesEmissaoGuia.email &&
              informacoesEmissaoGuia.emailEnviado
            "
          >
            <b-alert show variant="warning">
              <b-icon variant="warning" icon="exclamation-diamond-fill" />
              Foi enviada uma mensagem para o e-mail
              {{ informacoesEmissaoGuia.email }} com um código de confirmação. É
              obrigatório o preenchimento para dar continuidade na emissão do
              parcelamento. Favor verificar se a mensagem foi recebida. Caso não
              receba verifique mensagens bloqueadas e spam.</b-alert
            >
          </div>

          <div
            v-if="
              informacoesEmissaoGuia.telefoneCelular &&
              informacoesEmissaoGuia.telefoneEnviado
            "
          >
            <b-alert show variant="warning">
              <b-icon variant="warning" icon="exclamation-diamond-fill" />
              Foi enviada uma mensagem para o número
              {{ informacoesEmissaoGuia.telefoneCelular }} com um código de
              confirmação. É obrigatório o preenchimento para dar continuidade
              na emissão de DRAM para parcelamento. Favor verificar se a
              mensagem foi recebida. Caso não receba verifique mensagens
              bloqueadas e spam.
            </b-alert>
          </div>

          <b-row v-if="!mostrarConfirmacaoEmissaoGuia" class="float-right">
            <b-button
              variant="primary"
              class="mr-3"
              @click="enviarSMSEmissaoGuiaParcelamento()"
              :disabled="
                informacoesEmissaoGuia.cpfCnpj.length < 11 ||
                informacoesEmissaoGuia.telefoneCelular.length < 14
              "
            >
              Enviar SMS
            </b-button>

            <b-button
              variant="primary"
              class="mr-3"
              @click="enviarEmailEmissaoGuiaParcelamento()"
              :disabled="
                informacoesEmissaoGuia.cpfCnpj.length < 11 ||
                (informacoesEmissaoGuia.email.length < 6 &&
                  !informacoesEmissaoGuia.email.includes('@'))
              "
            >
              Enviar E-mail
            </b-button>
          </b-row>

          <b-row v-else class="float-right">
            <b-button
              variant="secondary"
              class="mr-3"
              @click="enviarSMSEmissaoGuiaParcelamento()"
              :disabled="informacoesEmissaoGuia.telefoneCelular.length < 14"
            >
              Reenviar SMS
            </b-button>

            <b-button
              variant="secondary"
              class="mr-3"
              @click="enviarEmailEmissaoGuiaParcelamento()"
              :disabled="
                informacoesEmissaoGuia.email.length < 6 &&
                !informacoesEmissaoGuia.email.includes('@')
              "
              >Reenviar E-mail</b-button
            >

            <b-button
              variant="primary"
              class="mr-3"
              @click="finalizarEmissaoGuiaEmLista()"
              :disabled="informacoesEmissaoGuia.codigoEmissaoGuia.length <= 5"
            >
              Confirmar emissão
            </b-button>
          </b-row>
        </b-modal>

        <b-modal
          ref="dialog-confirmar-parcelamento"
          hide-footer
          title="Confirmação de parcelamento"
          size="xs"
          modal-class="small-modal"
          centered
        >
          <p>
            Não foram selecionados todos os débitos do tipo "{{
              orgaoCobranca.DESCRICAO
            }}" para esta emissão. Você deseja prosseguir com esta seleção?
          </p>

          <b-button-group class="w-100">
            <b-button
              colspan="6"
              variant="outline-secondary "
              @click="fecharModal('dialog-confirmar-parcelamento')"
              >Não</b-button
            >
            <b-button colspan="6" class="ml-3" variant="primary" @click="t()"
              >Sim</b-button
            >
          </b-button-group>
        </b-modal>

        <b-modal
          ref="dialog-confirmar-a-vista"
          hide-footer
          title="Confirmação de pagamento à vista"
          size="sm"
          modal-class="small-modal"
          centered
        >
          <p>
            Não foram selecionados todos os débitos do tipo "{{
              orgaoCobranca.DESCRICAO
            }}" para esta emissão. Você deseja prosseguir com esta seleção?
          </p>

          <b-button-group class="w-100">
            <b-button
              colspan="6"
              variant="outline-secondary "
              @click="fecharModal('dialog-confirmar-a-vista')"
              >Não</b-button
            >
            <b-button
              colspan="6"
              class="ml-3"
              variant="primary"
              @click="
                abrirModalPagamentoAVistaSeNecessario('modal-pagamento-a-vista')
              "
              >Sim</b-button
            >
          </b-button-group>
        </b-modal>
        <!--  -->
      </div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import validarCpfCnpj from "../validations";
import { validarIPTU } from "../utils/validarIndiceCadastral";
import constantes from "../constants/index";
import tabelaGuiasVista from "../components/tabelaGuiasVista.vue";
import tabelaListaParcelamento from "../components/tabelaListaParcelamento.vue";
import moment from "moment";
import normalizaMensagemApi from "../helpers/normalizaMensagemApi";
import carregaTiposIdentificadores from "../composables/carregaTiposIdentificadores";

export default {
  components: {
    loading,
    tabelaGuiasVista,
    tabelaListaParcelamento,
  },
  directives: {
    mask,
  },
  data() {
    return {
      carregando: false,

      tooltipMaskIdentificador: "",

      placeHolderIdentificador: "",
      mascaraIdentificador: {},
      identificador: "",
      tokens: {
        L: {
          pattern: /[A-Za-z ]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        J: {
          pattern: /[0-9xX]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        E: {
          pattern: /[A-Za-z0-9 ]/,
          transform: function (v) {
            if (v.match(/\d/)) return " " + v;
            else return v.toLocaleUpperCase();
          },
        },
        X: {
          pattern: /[A-Za-z0-9]/,
          transform: function (v) {
            return v.toLocaleUpperCase();
          },
        },
        "#": { pattern: /\d/ },
      },

      origemAcesso: "",
      userName: "",
      origemNome: "",

      itemsGrupo: [],

      opcaoParcelaSelecionada: null,
      selected: [],
      allSelected: false,
      indeterminate: false,
      permiteParcelar: false,
      existePrescrito: false,

      selectAllRows: false,
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,

      mensagem: "",
      mensagemSucesso: [],
      mensagemErro: [],

      mensagemSucessoFormaPagto: [],
      mensagemErroFormaPagto: [],

      mostrarSelecaoLancamentos: false,
      mostrarSelecaoDebitos: false,
      mostrarMensagemDebitosInexistentes: false,
      mensagemLancamentos: [],
      mensagemParcelamento: [],
      mensagemEmissaoGuia: [],
      mensagemEmissaoGuiaSucesso: [],

      mensagemValidacaoCPFCNPJ: "",
      erroValidacaoCPFCNPJ: "",

      mensagemValidacaoIptu: "",
      erroValidacaoIptu: "",

      mensagemValidacaoIdentificador: "",
      erroValidacaoIdentificador: "",

      mensagemValidacaoParcelamento: "",
      erroValidacaoParcelamento: "",

      mensagemValidacaoCodigoParcelamento: "",
      erroValidacaoCodigoParcelamento: "",

      mensagemValidacaoPlacaVeiculo: "",
      erroValidacaoPlacaVeiculo: "",

      mensagemValidacaoLancamento: "",
      erroValidacaoLancamento: "",

      desabilitacodigoNacional: true,
      desabilitaIdentificador: false,
      desabilitaParcelamento: false,
      desabilitanomeContribuinte: true,

      habilitaBotaoSelecionarGuia: false,

      opcoesIdentificador: [],
      opcoesParcelar: [],

      btnSelecionados: [],
      btnSelecionadosParcelamento: [],

      parcelamentoSelecionado: [],

      dadosGuiaParcelamentoTacito: {
        pidtipoEmissao: 0,
        pidoperadorsistema: 0,
        pqtdparcelas: 0,
        pvalorparcela: 0,
        pvalordeposito: 0,
        ppercdeposito: 0,
        pidregraparcelamento: 0,
        pidfaixasregras: 0,
        pListaLancamentos: [],
        pemail: "",
        ptelefone: "",
        pusuario: "",
      },

      pIndiceCadastral: "",
      pCPF: "",
      pNome: "",

      emailInformado: "",
      telefoneInformado: "",

      dadosContribuinte: {
        cadastroNacional: "",
        cpf: "",
        nomeContribuinte: "",
        cnpj: "",
        tipoIdentificador: 0,
        identificador: "",
        numeroParcelamento: "",
        placaVeiculo: "",
        codigoLancamento: "",
        processoJudicial: "",
        transacao: "",
      },

      mostrarDemaisInformacoes: false,
      mostrarErroMuitosLancamentos: false,
      mostrarEnderecoCorrespondencia: false,
      mostrarEnderecoImovel: false,
      mostrarListaOpcoes: false,
      bloquearIndiceCadastral: false,
      bloquearCepNumero: false,
      bloquearLogradouroBairro: false,
      mostrarDemaisCamposEndereco: false,
      informacaoContribuinte: {
        cadastroNacional: "",
        nome: "",
        idPessoa: null,
        idPessoaPapel: null,
        idParcelamento: null,
        codigoLancamento: "",
        placaVeiculo: "",
        processoJudicial: "",
        transacao: "",
      },

      endereco: {
        tipoLogradouro: "",
        logradouro: "",
        complemento: "",
        cep: "",
        numero: "",
        bairro: "",
        municipio: "",
        estado: "",
        indiceCadastral: "",
      },

      enderecoImovel: {
        indiceCadastral: "",
        idEndereco: "",
        idTipoLogradouro: "",
        idLogradouro: "",
        idBairroPopular: "",
        numero: "",
      },

      listaLoteCTM: [],
      opcaoLoteCTM: null,

      lancamentosSelecionados: [],
      debitosSelecionados: [],
      demaisParcelamento: [],
      parcelamentoCessao: [],

      pidtipoemissao: "",
      pidoperadorsistema: "",

      exibirSomenteAviso: true,

      selecLanctosParctoTacito: [],
      selecGuiasParctoTacito: [],

      listaParcelamentosCalc: [],
      imovel: null,
      listaTiposComplemento: [],
      tipoComplemento1: "",
      complemento1: "",
      tipoComplemento2: "",
      complemento2: "",
      tipoComplemento3: "",
      complemento3: "",

      periodoInterrupcao: "",
      dataLiberadaInterrupcao: "",
      anoIPTU: "",

      preencheIptuOK: false,

      listaGuias: [],
      bloquearExibirLancamentos: false,
      verLancamentos: false,
      exibirDebitos: false,
      exibirDebitosSelecionados: false,
      exibirFormaPagamento: false,
      exibirListaGuia: false,
      exibirListaGuiaParcelar: false,
      exibirParcelamento: false,
      exibeBotaoPesquisar: false,

      reinicializarSelecao: false,
      refazerAgrupamento: false,

      selecionarTodosLancamentos: false,
      cabecalhoLancamento: [
        { label: "", key: "selected" },

        {
          label: "Descrição Débito",
          key: "DESCRICAO_LANCAMENTO",
        },
        { label: "", key: "detalhar" },

        { label: "Identificador", key: "IDENTIFICADOR" },
        {
          label: "Lançamento",
          key: "CODIGO_LANCAMENTO",
        },
        {
          label: "Transação / Parcelamento",
          key: "NUMERO_PARCELAMENTO",
        },
        {
          label: "Situação",
          key: "ESTADO_LANCAMENTO",
        },
        {
          label: "Inscrito em dívida ativa",
          key: "IND_INSCRITO",
        },
        {
          label: "Valor Total",
          key: "VALOR_TOTAL", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à Vista",
          key: "VALOR_DESCONTO", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
      ],

      cabecalhoDebitosSelecionados: [
        {
          label: "Descrição Débito",
          key: "DESCRICAO_LANCAMENTO",
        },
        { label: "", key: "detalhar" },
        { label: "Identificador", key: "IDENTIFICADOR" },
        {
          label: "Lançamento",
          key: "CODIGO_LANCAMENTO",
        },
        {
          label: "Transação / Parcelamento",
          key: "NUMERO_PARCELAMENTO",
        },
        {
          label: "Situação",
          key: "ESTADO_LANCAMENTO",
        },
        {
          label: "Inscrito em dívida ativa",
          key: "IND_INSCRITO",
        },
        {
          label: "Valor Total",
          key: "VALOR_TOTAL", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à Vista",
          key: "VALOR_DESCONTO", // Criado pelo template do tabela
          formatter: this.formatCurrency,
        },
      ],

      items: [],
      bloqueiaOpcao: false,
      fields: [],
      cabecalhoGuias: [
        {
          label: "Descrição",
          key: "DESCRICAO",
        },
        {
          label: "Numero da DRAM",
          key: "NUMEROGUIA",
          formatter: this.formatGuia,
        },
        {
          label: "Vencimento",
          key: "DATAVENCIMENTO",
          formatter: this.formatDateTime,
        },
        {
          label: "Valor total",
          key: "VALORTOTAL",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
        {
          label: "",
          key: "URLEMISSAO",
        },
        {
          label: "",
          key: "URLRELACAO",
        },
      ],

      cabecalhosubitem: [
        { label: "", key: "lista_opcao_parcto" },
        {
          label: "Parcela",
          key: "AQtdParcela",
        },

        {
          label: "Valor parcela",
          key: "AVlrParcela",
          formatter: this.formatCurrency,
        },

        {
          label: "Valor desconto",
          key: "AVlrdesconto",
          formatter: this.formatCurrency,
        },
      ],

      cabecalhoGuiasParcelado: [
        { label: "", key: "selected" },
        {
          key: "lista_opcao_parcto",
        },
        {
          label: "Descrição",
          key: "descricao_grupo",
        },
        {
          label: "lista_lancamento",
          key: "lista_lancamento",
        },
      ],

      listaDemaisParcelamentos: [],
      escolhaDemaisParcelamentos: "",

      listaCessao: [],
      escolhaCessao: "",

      cabecalhoEmissaoGuia: [
        {
          label: "Número do Parcelamento",
          key: "NROPARCELAMENTO",
        },
        {
          label: "Quantidade de Parcelas",
          key: "QTDPARCELAS",
        },
        {
          label: "Quantidade de Parcelas em Aberto",
          key: "QTDPARCELASABERTAS",
        },
        {
          label: "Saldo Atualizado",
          key: "VALORATUALIZADO",
          formatter: this.formatCurrency,
        },
        {
          label: "Valor à vista com desconto",
          key: "VALORDESCONTO",
          formatter: this.formatCurrency,
        },
      ],

      opcoesOrgaosCobranca: [],
      orgaoCobranca: [],
      orgao: [],
      listaAgrupamentos: [],
      listaNiveis: [],

      lancamentos: [],
      carregandoTabelaLancamentos: false,

      calculos: {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      },

      cnpjsRelacionados: [],

      calculosNovo: [],
      opcoesParcelamento: [],

      somenteParcelado: false,
      mostrarCessao: false,
      mostrarDemais: false,

      permitirCancelar: false,
      bloqueioEmissaoGuia: false,
      lancamentosEmissaoGuia: [],

      popoverShow: false,

      proibidos: [],

      informacoesEmissaoGuia: {
        cpfCnpj: "",
        razaoSocial: "",
        telefoneCelular: "",
        email: "",
        codigoEmissaoGuia: "",
        confirmacao: "",
        emailEnviado: false,
        telefoneEnviado: false,
        listaParcelamento: [],
        dadosExibicao: [],
      },

      tokenEmissaoGuia: "",
      mostrarConfirmacaoEmissaoGuia: false,

      informacaoParcelamento: {
        telefone: "",
        email: "",
      },

      listaGuiasParcelamento: [],
      listaOpcoesParcelamentoInternas: [],
      opcoesParcto: [],
      opcaoParctoSelecionada: "",
      escolhaOpcaoParcelamentoInterna: "",
      listaUrlsGuias: [],
    };
  },
  methods: {
    formatarValorComData: function () {
      var elemento = document.getElementById("valor");
      var valor = elemento.value;

      valor = valor + "";
      valor = parseInt(valor.replace(/[\D]+/g, ""));
      valor = valor + "";
      valor = valor.replace(/([0-9]{4})$/g, "/$1");
      elemento.value = valor;
      if (valor == "NaN") elemento.value = "";
    },
    focusInput: function (campo) {
      document.getElementById(campo).focus();
    },
    handleCarregaTiposIdentificadores: async function () {
      carregaTiposIdentificadores().then((opcoes) => {
        this.opcoesIdentificador = opcoes;
      }).catch((err) => {
        const mensagem = normalizaMensagemApi(err);
        this.mensagemErro.push(mensagem);
        window.scrollTo(0, 0);
      });
    },
    limparTudo: function () {
      this.mensagemValidacaoIPTU = "";
      this.informacaoContribuinte.indiceCadastral = "";
      this.preencheIptuOK = false;
      this.bloquearIndiceCadastral = false;
      this.bloquearCepNumero = false;
      this.bloquearLogradouroBairro = false;
      this.informacaoContribuinte.indiceCadastral = "";
      this.imovel = null;
      this.endereco.cep = "";
      this.endereco.numero = "";
      this.endereco.tipoLogradouro = "";
      this.endereco.logradouro = "";
      this.endereco.bairro = "";
      this.endereco.municipio = "";
      this.endereco.estado = "";
      this.endereco.indiceCadastral = "";
      this.endereco.complemento = "";
      this.tipoComplemento1 = "";
      this.complemento1 = "";
      this.tipoComplemento2 = "";
      this.complemento2 = "";
      this.tipoComplemento3 = "";
      this.complemento3 = "";
      this.mostrarEnderecoCorrespondencia = false;
      this.mostrarListaOpcoes = false;
      this.mostrarEnderecoImovel = false;
      this.opcaoLoteCTM = null;
      this.mostrarDemaisCamposEndereco = false;
      this.mensagemErro = [];
      this.mensagemSucesso = [];
    },

    pesquisar: async function () {
      this.bloquearCepNumero = false;
      this.bloquearLogradouroBairro = false;
      this.imovel = null;
      this.enderecoImovel.indiceCadastral = "";
      this.enderecoImovel.idEndereco = "";
      this.enderecoImovel.idTipoLogradouro = "";
      this.enderecoImovel.idLogradouro = "";
      this.enderecoImovel.idBairroPopular = "";
      this.enderecoImovel.numero = "";
      this.tipoComplemento1 = "";
      this.complemento1 = "";
      this.tipoComplemento2 = "";
      this.complemento2 = "";
      this.tipoComplemento3 = "";
      this.complemento3 = "";
      this.mostrarEnderecoCorrespondencia = false;
      this.mostrarListaOpcoes = false;
      this.mostrarEnderecoImovel = false;
      this.opcaoLoteCTM = null;
      this.mostrarDemaisCamposEndereco = false;

      this.mensagemErro = [];
      this.mensagemSucesso = [];

      this.desabilitarAba("all");

      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.carregando = true;
      this.novaPesquisa = "S";

      let imovel = null;

      if (!this.informacaoContribuinte.indiceCadastral) {
        this.carregando = false;
        this.mensagemErro.push(
          "É necessário informar um índice cadastral válido."
        );
        window.scrollTo(0, 0);
        return;
      }

      await this.$axios
        .post(this.$env.url_backend + constantes.buscaImoveisIndice, {
          indiceCadastral: this.informacaoContribuinte.indiceCadastral,
        })
        .then((response) => {
          const retorno = response.data;

          imovel = retorno[0];
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });

      if (imovel != null) {
        let permitir = 1;
        this.pIndiceCadastral = imovel.INDICE_CADASTRAL;
        this.pCPF = this.userName;
        this.pNome = this.dadosContribuinte.nomeContribuinte;

        if (permitir > 0) {
          this.imovel = imovel;
          this.carregando = false;
          this.mostrarEnderecoImovel = true;
          this.enderecoImovel.indiceCadastral =
            this.informacaoContribuinte.indiceCadastral;
          this.bloquearIndiceCadastral = true;
        } else {
          this.carregando = false;
          this.mensagemErro.push(
            "O CPF logado no GovBr precisa ser de um responsável pelo imóvel."
          );
          window.scrollTo(0, 0);
        }
      } else {
        this.carregando = false;
        this.mensagemErro.push(
          "Não foi encontrado nenhum imóvel para o índice cadastral informado."
        );
        window.scrollTo(0, 0);
      }
    },

    pesquisarAposGravar: async function () {
      this.bloquearCepNumero = false;
      this.bloquearLogradouroBairro = false;
      this.imovel = null;
      this.enderecoImovel.indiceCadastral = "";
      this.enderecoImovel.idEndereco = "";
      this.enderecoImovel.idTipoLogradouro = "";
      this.enderecoImovel.idLogradouro = "";
      this.enderecoImovel.idBairroPopular = "";
      this.enderecoImovel.numero = "";
      this.tipoComplemento1 = "";
      this.complemento1 = "";
      this.tipoComplemento2 = "";
      this.complemento2 = "";
      this.tipoComplemento3 = "";
      this.complemento3 = "";
      this.mostrarEnderecoCorrespondencia = false;
      this.mostrarListaOpcoes = false;
      this.mostrarEnderecoImovel = false;
      this.opcaoLoteCTM = null;
      this.mostrarDemaisCamposEndereco = false;

      this.mensagemErro = [];
      this.mensagemSucesso = [];

      this.desabilitarAba("all");

      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.carregando = true;
      this.novaPesquisa = "S";

      let imovel = null;

      if (!this.informacaoContribuinte.indiceCadastral) {
        this.carregando = false;
        this.mensagemErro.push(
          "É necessário informar um índice cadastral válido."
        );
        window.scrollTo(0, 0);
        return;
      }

      await this.$axios
        .post(
          this.$env.url_backend + constantes.buscaImoveisIndiceSemRecaptcha,
          {
            indiceCadastral: this.informacaoContribuinte.indiceCadastral,
          }
        )
        .then((response) => {
          const retorno = response.data;

          imovel = retorno[0];
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });

      if (imovel != null) {
        let permitir = 1;

        if (permitir > 0) {
          this.imovel = imovel;
          this.carregando = false;
          this.mostrarEnderecoImovel = true;
          this.enderecoImovel.indiceCadastral =
            this.informacaoContribuinte.indiceCadastral;
          this.bloquearIndiceCadastral = true;
        } else {
          this.carregando = false;
          this.mensagemErro.push(
            "O CPF logado no GovBr precisa ser de um responsável pelo imóvel."
          );
          window.scrollTo(0, 0);
        }

        this.mensagemSucesso.push("Endereço gravado com sucesso.");
      } else {
        this.carregando = false;
        this.mensagemErro.push(
          "Não foi encontrado nenhum imóvel para o índice cadastral informado."
        );
        window.scrollTo(0, 0);
      }
    },

    validarIndiceCadastralParaCPF: async function (
      indiceCadastral,
      codigoNacional
    ) {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      let count = 0;

      await this.$axios
        .post(
          this.$env.url_backend + constantes.validarIndiceCadastralParaCPF,
          {
            indiceCadastral: indiceCadastral,
            codigoNacional: codigoNacional,
          }
        )
        .then((response) => {
          const retorno = response.data;

          count = retorno[0].COUNT;
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
      return count;
    },

    buscarListaLoteCTMPorIndiceCadastral: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.listaLoteCTM = [];

      this.desabilitarAba("all");

      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.carregando = true;
      this.novaPesquisa = "S";

      if (!this.enderecoImovel.indiceCadastral) {
        this.carregando = false;
        this.mensagemErro.push(
          "É necessário informar um índice cadastral válido."
        );
        window.scrollTo(0, 0);
        return;
      }

      await this.$axios
        .post(
          this.$env.url_backend +
            constantes.buscaListaLoteCTMPorIndiceCadastral,
          {
            indiceCadastral: this.enderecoImovel.indiceCadastral,
          }
        )
        .then((response) => {
          const retorno = response.data;

          let listaLoteCTM = retorno;

          if (listaLoteCTM != null) {
            listaLoteCTM.map((loteCTM) =>
              this.listaLoteCTM.push({
                text: loteCTM.DESCRICAO,
                value: loteCTM,
              })
            );
            this.mostrarListaOpcoes = true;
            this.carregando = false;
          } else {
            this.carregando = false;
            this.mensagemErro.push(
              "Não foi encontrado nenhum lote CTM para o índice cadastral informado."
            );
            window.scrollTo(0, 0);
          }
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    pesquisarEnderecoPorCepNumero: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];

      this.desabilitarAba("all");

      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.carregando = true;
      this.novaPesquisa = "S";

      if (this.endereco.cep.length < 10) {
        this.carregando = false;
        this.mensagemErro.push("É necessário informar um cep válido.");
        window.scrollTo(0, 0);
        return;
      }

      if (this.endereco.numero.length < 1) {
        this.carregando = false;
        this.mensagemErro.push("É necessário informar um número.");
        window.scrollTo(0, 0);
        return;
      }

      await this.$axios
        .post(this.$env.url_backend + constantes.buscaEnderecoPorCepNumero, {
          cep: this.endereco.cep,
          numero: this.endereco.numero,
        })
        .then((response) => {
          const retorno = response.data;

          let endereco = null;
          endereco = retorno[0];

          if (endereco) {
            this.bloquearCepNumero = true;
            if (endereco.LOGRADOURO.trim().length > 0) {
              this.bloquearLogradouroBairro = true;
            } else {
              this.bloquearLogradouroBairro = false;
            }
            this.endereco.cep = endereco.CEP;
            this.endereco.tipoLogradouro = endereco.TIPO_LOGRADOURO;
            this.endereco.logradouro = endereco.LOGRADOURO;
            this.endereco.bairro = endereco.BAIRRO;
            this.endereco.municipio = endereco.MUNICIPIO;
            this.endereco.estado = endereco.ESTADO;
            this.carregando = false;
            this.mostrarDemaisCamposEndereco = true;
            this.buscarTiposComplemento();
          } else {
            this.mensagemErro.push("Cep não encontrado.");
            window.scrollTo(0, 0);
          }
          this.carregando = false;
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    buscarTiposComplemento: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];

      await this.$axios
        .post(this.$env.url_backend + constantes.buscaTiposComplemento, {})
        .then((response) => {
          const retorno = response.data;

          let listaTiposComplemento = retorno;

          this.listaTiposComplemento.push({ value: "", text: "Selecione" });
          if (listaTiposComplemento != null) {
            listaTiposComplemento.map((tipoComplemento) =>
              this.listaTiposComplemento.push({
                value: tipoComplemento.DESCRICAO,
                text: tipoComplemento.DESCRICAO,
              })
            );
          } else {
            this.mensagemErro.push(
              "Não foi encontrado nenhum tipo de complemento."
            );
          }
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    gravarEndereco: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.carregando = true;

      if (this.tipoComplemento1 != "" && this.complemento1 != "") {
        this.endereco.complemento =
          this.tipoComplemento1 + " " + this.complemento1;
      }

      if (this.tipoComplemento2 != "" && this.complemento2 != "") {
        if (this.endereco.complemento.length > 0) {
          this.endereco.complemento =
            this.endereco.complemento +
            " " +
            this.tipoComplemento2 +
            " " +
            this.complemento2;
        } else {
          this.endereco.complemento =
            this.tipoComplemento2 + " " + this.complemento2;
        }
      }

      if (this.tipoComplemento3 != "" && this.complemento3 != "") {
        if (this.endereco.complemento.length > 0) {
          this.endereco.complemento =
            this.endereco.complemento +
            " " +
            this.tipoComplemento3 +
            " " +
            this.complemento3;
        } else {
          this.endereco.complemento =
            this.tipoComplemento3 + " " + this.complemento3;
        }
      }

      await this.$axios
        .post(this.$env.url_backend + constantes.gravaEndereco, {
          endereco: this.endereco,
        })
        .then((response) => {
          const retorno = response.data;

          if (retorno === "OK") {
            this.pesquisarAposGravar();
            window.scrollTo(0, 0);
          } else {
            this.mensagemErro.push("Erro na gravação de endereço.");
            window.scrollTo(0, 0);
          }
          this.carregando = false;
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    gravarEnderecoImovel: async function () {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      this.carregando = true;

      if (this.opcaoLoteCTM != null) {
        this.enderecoImovel.idEndereco = this.opcaoLoteCTM.IDENDERECO;
        this.enderecoImovel.idTipoLogradouro =
          this.opcaoLoteCTM.IDTIPOLOGRADOURO;
        this.enderecoImovel.idLogradouro = this.opcaoLoteCTM.IDLOGRADOURO;
        this.enderecoImovel.idBairroPopular = this.opcaoLoteCTM.IDBAIRROPOPULAR;
        this.enderecoImovel.numero = this.opcaoLoteCTM.NUMERO;
      } else {
        this.mensagemErro.push(
          "É necessário selecionar uma opção para novo endereço."
        );
        window.scrollTo(0, 0);
        this.carregando = false;
        return;
      }
      const dataSys = new Date();
      let dataSysSincrBanco = new Date();
      dataSysSincrBanco.setMinutes(dataSys.getMinutes() - 2);

      const inicioGravacaoIptuWS = this.formatarData(dataSysSincrBanco);

      await this.$axios
        .post(this.$env.url_backend + constantes.gravaNovoEnderecoImovel, {
          endereco: this.enderecoImovel,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno === "OK") {
            let persistiuOK = false;
            persistiuOK = this.atualizarLogado(inicioGravacaoIptuWS);
            if (persistiuOK) {
              this.pesquisarAposGravar();
            }
          } else {
            this.mensagemErro.push(retorno);
            window.scrollTo(0, 0);
          }
          window.scrollTo(0, 0);
          this.carregando = false;
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    /// atualiza tabela logado_Gov_Br com cpf do logado e id_imovel
    atualizarLogado: async function (dataHora) {
      this.mensagemErro = [];
      this.mensagemSucesso = [];
      let result = false;
      try {
        await this.$axios
          .post(this.$env.url_backend + constantes.atualizarLogadoGovBr, {
            opcao: "enderImovel",
            indiceCadastral: this.pIndiceCadastral,
            codigoNacional: this.pCPF,
            contribuinte: this.pNome,
            inicioGravacaoIptuWS: dataHora,
          })
          .then((response) => {
            const retorno = response.data;
            if (retorno == "OK") result = true;
            else result = false;
          });
      } catch (error) {
        result = false;
      }
      return result;
    },

    abreGuiaParcelamento: async function () {
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaGuiaParcelamento, {
          idParcelamento: this.informacaoContribuinte.idParcelamento,
          usuario: this.userName,
        })
        .then((response) => {
          this.listaGuiasParcelamento = [];
          const retorno = response.data;
          const objetoGuiasParcelamento = retorno[0];
          if (objetoGuiasParcelamento.AMENSAGEM_RETORNO === "OK") {
            this.listaGuiasParcelamento = objetoGuiasParcelamento.ALISTA;
            this.carregando = false;
          } else {
            this.carregando = false;
            this.mensagemErro.push(
              objetoGuiasParcelamento.AMENSAGEM_RETORNO
              // "Erro ao recuperar as guias referentes ao parcelamento informado."
            );
            window.scrollTo(0, 0);
          }
        })
        .catch((error) => {
          this.carregando = false;
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    lancamentosAgrupados: async function () {
      this.carregandoTabelaLancamentos = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];
      this.mensagemErro = [];
      this.mostrarMensagemDebitosInexistentes = false;

      this.informacaoContribuinte.idPessoa =
        this.informacaoContribuinte.idPessoa || null;
      this.informacaoContribuinte.idPessoaPapel =
        this.informacaoContribuinte.idPessoaPapel || null;
      this.informacaoContribuinte.idParcelamento =
        this.informacaoContribuinte.idParcelamento || null;

      await this.$axios
        .post(this.$env.url_backend + constantes.agrupaLancamentos, {
          informacaoContribuinte: this.informacaoContribuinte,
        })
        .then((response) => {
          const retorno = response.data;
          const listaLancamentos = retorno[0];

          if (
            listaLancamentos.LISTA_AGRUPAMENTO === null ||
            listaLancamentos.LISTA_AGRUPAMENTO.length === 0 ||
            listaLancamentos.MENSAGEM_RETORNO !== "OK"
          ) {
            this.mostrarSelecaoDebitos = false;
            this.mostrarMensagemDebitosInexistentes = true;
            this.listaAgrupamentos = [];
            this.carregando = false;
          }
          if (listaLancamentos.MENSAGEM_RETORNO === "OK") {
            this.mostrarSelecaoLancamentos = true;
            this.mostrarSelecaoDebitos = true;
            this.listaAgrupamentos = [];

            const lancamentos = [];

            listaLancamentos.LISTA_AGRUPAMENTO.map((lancamento) =>
              lancamentos.push(lancamento)
            );
            this.listaAgrupamentos = lancamentos;
            this.listaNiveis = this.montaAgrupamento(lancamentos);
          }

          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
        })
        .catch((err) => {
          this.carregando = false;
          this.carregandoTabelaLancamentos = false;
          const mensagem = normalizaMensagemApi(err);
          this.mensagemErro.push(mensagem);
          window.scrollTo(0, 0);
        });
    },

    retornaCalculos: async function () {
      this.carregando = true;
      this.listaDemaisParcelamentos = [];
      this.listaCessao = [];

      this.mensagemErroFormaPagto = [];
      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const agrupamento = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.AGRUPAMENTO
      );

      const userName = this.userName;

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaCalculos, {
          lancamentosSelecionados: lancamentos,
          agrupamentoSelecionados: agrupamento,
          usuario: userName,
        })
        .then((response) => {
          const retorno = response.data;
          const calculosRetornados = retorno[0];
          this.calculos = calculosRetornados;
          if (this.calculos.TLISTAURLGUIA === null)
            this.mensagemErroFormaPagto.push(
              `Falha ao gerar DRAM. Favor entrar em contato pelo e-mail gecda@pbh.gov.br`
            );
          else {
            this.exibirListaGuia = true;
          }
        })
        .catch((error) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErroFormaPagto.push(mensagem);
        });

      this.carregando = false;
    },

    retornaCalculosParcelar: async function () {
      this.carregando = true;
      this.mensagemErroFormaPagto = [];

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaCalculosParcelar, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].length == 10)
            this.mensagemErroFormaPagto.push(
              `Não encontrou débito para o dado selecionado`
            );
          else {
            const calculosRetornados = retorno[0];
            this.opcoesParcelamento = calculosRetornados;
            this.listaParcelamentosCalc = this.montaAgrupamentoParcto(
              this.opcoesParcelamento,
              lancamentos
            );

            this.exibirListaGuiaParcelar = true;
            this.selecLanctosParctoTacito = [];
            this.selecGuiasParctoTacito = [];
          }
        })
        .catch((error) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
        });

      this.carregando = false;
    },

    enviarSMSEmissaoGuiaParcelamento: async function () {
      this.mensagemEmissaoGuiaSucesso = [];
      this.mensagemEmissaoGuia = [];
      //  buscar codigo de envio  //
      const emailConfirmacao = this.informacoesEmissaoGuia.email;
      const telefoneConfirmacao = this.informacoesEmissaoGuia.telefoneCelular;

      this.emailInformado = emailConfirmacao;
      this.telefoneInformado = telefoneConfirmacao;

      const informacaoConfirmacao = { emailConfirmacao, telefoneConfirmacao };

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarCodigoConfirmacao, {
          informacaoConfirmacao,
        })
        .then((response) => {
          const retorno = response.data;
          this.informacoesEmissaoGuia.confirmacao = retorno[0];
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });

      const telefone = this.informacoesEmissaoGuia.telefoneCelular;
      const codigoEmissaoGuia = this.informacoesEmissaoGuia.confirmacao;
      const acesso = this.origemAcesso;
      const contribuinte = this.dadosContribuinte.nomeContribuinte;

      const informacaoEmissaoGuia = {
        telefone,
        codigoEmissaoGuia,
        acesso,
        contribuinte,
      };

      await this.$axios
        .post(
          this.$env.url_backend + constantes.enviarSMSEmissaoGuiaParcelamento,
          {
            informacaoEmissaoGuia,
          }
        )
        .then(() => {
          this.mensagemEmissaoGuiaSucesso.push("SMS enviado com sucesso!");
          this.mostrarConfirmacaoEmissaoGuia = true;
          this.informacoesEmissaoGuia.telefoneEnviado = true;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.telefoneEnviado = false;
        });
    },

    enviarEmailEmissaoGuiaParcelamento: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      //  buscar codigo de envio  //
      const emailConfirmacao = this.informacoesEmissaoGuia.email;
      const telefoneConfirmacao = this.informacoesEmissaoGuia.telefoneCelular;

      this.emailInformado = emailConfirmacao;
      this.telefoneInformado = telefoneConfirmacao;

      const informacaoConfirmacao = { emailConfirmacao, telefoneConfirmacao };

      await this.$axios
        .post(this.$env.url_backend + constantes.buscarCodigoConfirmacao, {
          informacaoConfirmacao,
        })
        .then((response) => {
          const retorno = response.data;
          this.informacoesEmissaoGuia.confirmacao = retorno[0];
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });

      const email = this.informacoesEmissaoGuia.email;
      const codigoEmissaoGuia = this.informacoesEmissaoGuia.confirmacao;

      const informacaoEmissaoGuia = { email, codigoEmissaoGuia };

      await this.$axios
        .post(
          this.$env.url_backend + constantes.enviarEmailEmissaoGuiaParcelamento,
          {
            informacaoEmissaoGuia,
          }
        )
        .then(() => {
          this.mensagemEmissaoGuiaSucesso.push("E-mail enviado com sucesso!");
          this.mostrarConfirmacaoEmissaoGuia = true;
          this.informacoesEmissaoGuia.emailEnviado = true;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemEmissaoGuia.push(mensagem);
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = false;
        });
    },

    emitirGuiaParcelamento: async function () {
      this.mensagemParcelamento = [];

      const email = this.informacaoParcelamento.email;
      const telefone = this.informacaoParcelamento.telefone;
      const usuario = this.userName;

      const opcaoParctoInternaSelecionada =
        this.escolhaOpcaoParcelamentoInterna;

      if (opcaoParctoInternaSelecionada) {
        const lancamentos = this.lancamentosSelecionados.map(
          (lancamento) => lancamento.ID_LANCAMENTO
        );

        const informacaoGuia = {
          lancamentos,
          email,
          telefone,
          idOperadorSistema: 0,
          selecao: opcaoParctoInternaSelecionada,
          usuario,
        };

        this.guiaParcelamento(informacaoGuia);
      }
    },

    limparCamposEmissaoGuia: function () {
      this.informacoesEmissaoGuia.listaParcelamento = [];

      this.informacoesEmissaoGuia.cpfCnpj = "";
      this.informacoesEmissaoGuia.razaoSocial = "";
      this.informacoesEmissaoGuia.telefoneCelular = "";
      this.informacoesEmissaoGuia.telefoneEnviado = false;
      this.informacoesEmissaoGuia.email = "";
      this.informacoesEmissaoGuia.emailEnviado = false;
      this.mensagemLancamentos = [];
      this.mostrarConfirmacaoEmissaoGuia = false;
      this.informacoesEmissaoGuia.codigoEmissaoGuia = "";

      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
    },

    autenticarEmissao: function () {
      this.carregando = true;
      this.mensagemEmissaoGuia = [];

      this.informacoesEmissaoGuia.cpfCnpj =
        this.informacaoContribuinte.cadastroNacional;

      this.informacoesEmissaoGuia.razaoSocial =
        this.informacaoContribuinte.nome;

      this.carregando = false;
    },

    confirmarEmissaoGuia: async function () {
      this.carregando = true;
      this.mensagemEmissaoGuia = [];
      const lancamentosEmissaoGuia = this.lancamentosEmissaoGuia.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      const informacaoEmissaoGuia = { lancamentosEmissaoGuia };

      await this.$axios
        .post(this.$env.url_backend + constantes.confirmarEmissaoGuia, {
          informacaoEmissaoGuia,
        })
        .then((response) => {
          const retorno = response.data[0];

          this.informacoesEmissaoGuia.cpfCnpj =
            this.informacaoContribuinte.cadastroNacional;

          this.informacoesEmissaoGuia.razaoSocial =
            this.informacaoContribuinte.nome;
          if (retorno.AMENSAGEM === "OK") {
            this.informacoesEmissaoGuia.confirmacao = retorno.ACONFIRMACAO;
            this.informacoesEmissaoGuia.dadosExibicao = retorno.ADADOSEXIBICAO;
            this.informacoesEmissaoGuia.listaParcelamento =
              retorno.ALISTAPARCTOS;
            this.carregando = false;
          } else {
            this.mensagemEmissaoGuia.push(response.data.AMENSAGEM);
            this.carregando = false;
          }
        })
        .catch(() => {
          this.carregando = false;
          this.mostrarConfirmacaoEmissaoGuia = false;
        });
    },

    downloadArquivo: async function (pathurl) {
      window.open(pathurl);
    },

    exibirGuiaParcelamentoTacito: async function () {
      for (let i = 0, l = this.selecGuiasParctoTacito.length; i < l; i++) {
        this.dadosGuiaParcelamentoTacito.pidtipoEmissao = 4;
        this.dadosGuiaParcelamentoTacito.pidoperadorsistema = 0;
        this.dadosGuiaParcelamentoTacito.pqtdparcelas =
          this.selecGuiasParctoTacito[i].pqtdparcelas;
        this.dadosGuiaParcelamentoTacito.pvalorparcela =
          this.selecGuiasParctoTacito[i].pvalorparcela;
        this.dadosGuiaParcelamentoTacito.pvalordeposito =
          this.selecGuiasParctoTacito[i].pvalordeposito;
        this.dadosGuiaParcelamentoTacito.ppercdeposito =
          this.selecGuiasParctoTacito[i].ppercdeposito;
        this.dadosGuiaParcelamentoTacito.pidregraparcelamento =
          this.selecGuiasParctoTacito[i].pidregraparcelamento;
        this.dadosGuiaParcelamentoTacito.pidfaixasregras =
          this.selecGuiasParctoTacito[i].pidfaixasregras;
        this.selecGuiasParctoTacito.map((guia) => {
          guia.plancamentos.map((lancamento) => {
            this.dadosGuiaParcelamentoTacito.pListaLancamentos.push(lancamento);
          });
        });

        this.dadosGuiaParcelamentoTacito.pemail = this.emailInformado;
        this.dadosGuiaParcelamentoTacito.ptelefone = this.telefoneInformado;
        this.dadosGuiaParcelamentoTacito.pusuario = this.userName;

        // emite a guia
        this.carregando = true;
        this.limparMensagensDeErro();
        await this.$axios
          .post(
            this.$env.url_backend + constantes.emiteGuiaParcelamentoTacito,
            {
              dadosGuiaParcelamentoTacito: this.dadosGuiaParcelamentoTacito,
            }
          )
          .then((response) => {
            const retorno = response.data;
            const urlGuia = retorno[0].AURLEMISSAO;
            const mensOK = retorno[0].AMENSAGEM;
            if (mensOK === "OK") {
              this.downloadArquivo(urlGuia, "emissaoDRAM");
            }
            this.carregando = false;
          })
          .catch((error) => {
            this.limparCampos();
            this.carregando = false;
            const mensagem = normalizaMensagemApi(error);
            this.mensagemErro.push(mensagem);
            window.scrollTo(0, 0);
          });

        this.dadosGuiaParcelamentoTacito = {
          pidtipoEmissao: 0,
          pidoperadorsistema: 0,
          pqtdparcelas: 0,
          pvalorparcela: 0,
          pvalordeposito: 0,
          ppercdeposito: 0,
          pidregraparcelamento: 0,
          pidfaixasregras: 0,
          pListaLancamentos: [],
          pemail: "",
          ptelefone: "",
          pusuario: "",
        };
      }
    },

    exibirGuiaParcelamentoTacitoEmLista: async function () {
      let pos = 0;
      for (let i = 0, l = this.selecGuiasParctoTacito.length; i < l; i++) {
        pos = this.selecGuiasParctoTacito[i].id;
        this.dadosGuiaParcelamentoTacito.pidtipoEmissao = 4;
        this.dadosGuiaParcelamentoTacito.pidoperadorsistema = 0;
        this.dadosGuiaParcelamentoTacito.pqtdparcelas =
          this.selecGuiasParctoTacito[i].pqtdparcelas;
        this.dadosGuiaParcelamentoTacito.pvalorparcela =
          this.selecGuiasParctoTacito[i].pvalorparcela;
        this.dadosGuiaParcelamentoTacito.pvalordeposito =
          this.selecGuiasParctoTacito[i].pvalordeposito;
        this.dadosGuiaParcelamentoTacito.ppercdeposito =
          this.selecGuiasParctoTacito[i].ppercdeposito;
        this.dadosGuiaParcelamentoTacito.pidregraparcelamento =
          this.selecGuiasParctoTacito[i].pidregraparcelamento;
        this.dadosGuiaParcelamentoTacito.pidfaixasregras =
          this.selecGuiasParctoTacito[i].pidfaixasregras;

        if (this.selecGuiasParctoTacito[i].pqtdparcelas === 0) {
          this.dadosGuiaParcelamentoTacito.pListaLancamentos.push(
            this.selecGuiasParctoTacito[i].plancamentos[0]
          );
        } else {
          this.listaParcelamentosCalc[i].lista_lancamento_agrupamento.map(
            (lancamento) => {
              this.dadosGuiaParcelamentoTacito.pListaLancamentos.push(
                lancamento
              );
            }
          );
        }

        this.dadosGuiaParcelamentoTacito.pemail = this.emailInformado;
        this.dadosGuiaParcelamentoTacito.ptelefone = this.telefoneInformado;
        this.dadosGuiaParcelamentoTacito.pusuario = this.origemAcesso;
        this.carregando = true;
        this.limparMensagensDeErro();
        await this.$axios
          .post(
            this.$env.url_backend + constantes.emiteGuiaParcelamentoTacito,
            {
              dadosGuiaParcelamentoTacito: this.dadosGuiaParcelamentoTacito,
            }
          )
          .then((response) => {
            const retorno = response.data;
            const urlGuia = retorno[0].AURLEMISSAO;
            const urlRelatorio = retorno[0].AURLRELATORIO;
            const mensOK = retorno[0].AMENSAGEM;
            if (mensOK === "OK") {
              this.listaParcelamentosCalc[pos].urlGuia = urlGuia;
              this.listaParcelamentosCalc[pos].urlRelatorio = urlRelatorio;
            }
            this.carregando = false;
          })
          .catch((error) => {
            this.limparCampos();
            this.carregando = false;
            const mensagem = normalizaMensagemApi(error);
            this.mensagemErro.push(mensagem);
            window.scrollTo(0, 0);
          });
        this.dadosGuiaParcelamentoTacito = {
          pidtipoEmissao: 0,
          pidoperadorsistema: 0,
          pqtdparcelas: 0,
          pvalorparcela: 0,
          pvalordeposito: 0,
          ppercdeposito: 0,
          pidregraparcelamento: 0,
          pidfaixasregras: 0,
          pListaLancamentos: [],
          pemail: "",
          ptelefone: "",
          pusuario: "",
        };
      }
    },

    finalizarEmissaoGuia: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      this.bloquearExibirLancamentos = false;

      if (this.origemAcesso === "GovBr") {
        this.exibirGuiaParcelamentoTacito();
        this.fecharModal("modal-EmissaoGuia");
        this.bloqueioEmissaoGuia = false;
        this.desabilitarAba("selecaoDebito");
      } else {
        if (
          this.informacoesEmissaoGuia.codigoEmissaoGuia ===
          this.informacoesEmissaoGuia.confirmacao
        ) {
          this.exibirGuiaParcelamentoTacito();
          this.fecharModal("modal-EmissaoGuia");
          this.bloqueioEmissaoGuia = false;
          this.desabilitarAba("selecaoDebito");
        } else {
          this.mensagemEmissaoGuia.push("O código inserido está incorreto.");
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = true;
        }
      }
    },

    finalizarEmissaoGuiaEmLista: async function () {
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];
      this.bloquearExibirLancamentos = false;
      if (this.origemAcesso === "GovBr" || !this.somenteParcelado) {
        this.exibirGuiaParcelamentoTacitoEmLista();
        this.fecharModal("modal-EmissaoGuia");
        this.bloqueioEmissaoGuia = false;
        this.bloqueiaOpcao = true;
      } else {
        if (
          this.informacoesEmissaoGuia.codigoEmissaoGuia ===
          this.informacoesEmissaoGuia.confirmacao
        ) {
          this.exibirGuiaParcelamentoTacitoEmLista();
          this.fecharModal("modal-EmissaoGuia");
          this.bloqueioEmissaoGuia = false;
          this.bloqueiaOpcao = true;
        } else {
          this.mensagemEmissaoGuia.push("O código inserido está incorreto.");
          this.carregando = false;
          this.informacoesEmissaoGuia.emailEnviado = true;
        }
      }
    },

    guiaParcelamento: async function (informacaoGuia) {
      this.mensagemParcelamento = [];
      this.carregando = true;
      await this.$axios
        .post(this.$env.url_backend + constantes.retornaGuiaParcelamentos, {
          informacaoGuia,
        })
        .then((response) => {
          const retorno = response.data;
          if (retorno[0].AMENSAGEM === "OK") {
            const url = retorno[0].AURLEMISSAO;
            this.downloadArquivo(url, "emissaoDRAM");
            this.carregando = false;
          } else {
            this.mensagemParcelamento.push(
              "Houve um erro ao gerar o DRAM de parcelamento."
            );
            this.carregando = false;
          }
        })
        .catch((error) => {
          this.carregando = false;
          this.fecharModal("modal-parcelamento");
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(error);
          this.mensagemParcelamento.push(mensagem);
        });
    },

    simularPagamento: async function () {
      this.mensagemErro = [];

      this.carregando = true;

      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.imprimeSimulacao, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const url = retorno[0];
          const link = url;

          this.downloadArquivo(link, "emissaoDRAM");
          this.carregando = false;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          this.mensagemErro.push(mensagem);
          this.fecharModal("modal-lancamentos");
          window.scrollTo(0, 0);
          this.carregando = false;
        });
    },

    guiaPagamentoAVista(url, ind1) {
      const str1 = ind1;
      this.chaveID = `${str1}`;

      const ind = this.btnSelecionadosParcelamento.findIndex(
        (e) => e.id === this.chaveID
      );

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionadosParcelamento =
          this.btnSelecionadosParcelamento.filter(
            (item) => item.id != this.chaveID
          );
      } // inclui ( clicado )
      else {
        this.btnSelecionadosParcelamento.push({ id: this.chaveID });
        const link = url;
        this.downloadArquivo(link, "emissaoDRAM");
      }
    },

    limparDadosTabela: function () {
      this.limparInformacoesTabela();
      this.lancamentosSelecionados = [];
      this.lancamentosEmissaoGuia = [];
      this.lancamentos = [];
      this.calculos = {};
    },

    limparInformacoesTabela: function () {
      this.permitirCancelar = false;
      this.bloqueioEmissaoGuia = false;
    },

    leftPad: function (value, totalWidth, paddingChar) {
      let length = totalWidth - value.toString().length + 1;
      return Array(length).join(paddingChar || "0") + value;
    },

    montaMascara: function (value) {
      if (!value) return "####################";
      let bar = "/";
      let maskedNumber = value.padStart(value.length, "*");
      let position = maskedNumber.length - 4;
      let output = [
        maskedNumber.slice(position),
        bar,
        maskedNumber.slice(position),
      ].join("");
      return output;
    },

    retornaBarra: function (value) {
      let bar = "/";
      let position = value.length - 4;
      let output = [value.slice(0, position), bar, value.slice(position)].join(
        ""
      );
      return output;
    },

    formatGuia: function (value) {
      if (!value) return "";
      else {
        let valor = value;
        valor = this.leftPad(valor, 13);
        valor = valor.replace(/(\d{2})(\d{2})(\d{7})(\d{2})$/, "$1.$2.$3.$4");
        return valor;
      }
    },

    formatDateTime: function (value) {
      if (!value) return "";
      else return moment(String(value)).format("DD/MM/YYYY");
    },

    formatCurrency: function (value) {
      if (value != null) {
        let formatter = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
        return formatter.format(value);
      } else {
        return "______";
      }
    },

    formatCPFCNPJ(value) {
      if (value === "0") return "Identificador não encontrado";
      if (!value) return "";
      else {
        value = value.replace(/[^\d]+/g, "");

        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
          return value;
        } else if (value.length === 14) {
          value = value.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
            "$1.$2.$3/$4-$5"
          );
          return value;
        }
      }
    },

    reinicializaIdentificador: function () {
      this.dadosContribuinte.Identificador = "";
      this.mensagemValidacaoIdentificador = "";
      //INSCRICAO MUNICIPAL
      if (this.dadosContribuinte.tipoIdentificador === 1) {
        this.placeHolderIdentificador = "Informe a Inscrição Municipal";
      }
      //CPF
      if (this.dadosContribuinte.tipoIdentificador === 3) {
        this.placeHolderIdentificador = "Informe o CPF";
      }
      //CNPJ
      if (this.dadosContribuinte.tipoIdentificador === 4) {
        this.placeHolderIdentificador = "Informe o CNPJ";
      }
      //perpetuidade
      if (this.dadosContribuinte.tipoIdentificador === 5) {
        this.placeHolderIdentificador = "Informe a Perpetuidade";
      }
      //PARCELAMENTO
      if (this.dadosContribuinte.tipoIdentificador === 14) {
        this.placeHolderIdentificador = "Informe o Parcelamento / ano";
      }
      //PROCESSO JUDICIAL
      if (this.dadosContribuinte.tipoIdentificador === 15) {
        this.placeHolderIdentificador = "Informe o Processo Judicial";
      }
      //ÍNDICE CADASTRAL
      if (this.dadosContribuinte.tipoIdentificador === 8) {
        this.placeHolderIdentificador = "Informe o Índice Cadastral";
      }
      //PLACA DE VEÍCULO
      if (this.dadosContribuinte.tipoIdentificador === 10) {
        this.placeHolderIdentificador = "Informe a Placa do Veículo";
      }
      //TRANSAÇAO
      if (this.dadosContribuinte.tipoIdentificador === 16) {
        this.placeHolderIdentificador = "Informe a Transação de ITBI / ano";
      }

      this.dadosContribuinte.identificador = "";
      this.mascaraIdentificador = {};
      this.habilitarCampos();
      this.focusInput("identificador");
    },

    getDebitosSelecionados(data) {
      this.orgaoCobranca = data;

      this.limparDadosTabela();
      this.lancamentos = [];
      this.calculos = {};

      this.orgaoCobranca.map((orgao) => {
        orgao.ALANCAMENTOS.map((lancamento) => {
          this.lancamentos.push(lancamento);
        });
      });
    },

    getSelecionados(data) {
      if (data.title === "lancamentos") {
        this.lancamentosSelecionados = data.selecionados;
        this.permiteParcelar = data.permiteParcelamento;
        this.existePrescrito = data.existePrescrito;
      }

      if (data.title === "emitirParcelamentosTacitos") {
        this.selecGuiasParctoTacito = data.selecionados;
        this.selecGuiasParctoTacito = data.selecionados;

        this.mensagemEmissaoGuia = [];
        this.mensagemEmissaoGuiaSucesso = [];
        this.somenteParcelado = false;
        this.mensagemErro = [];
        let emitirParcelamentoSemAutorizacao = false;
        if (this.selecGuiasParctoTacito.length === 0) {
          this.carregando = false;
          this.mensagemErro.push("Selecione pelo menos um parcelamento.");
          window.scrollTo(0, 0);
        } else {
          for (let i = 0, l = this.selecGuiasParctoTacito.length; i < l; i++) {
            if (this.selecGuiasParctoTacito[i].pqtdparcelas > 0) {
              this.somenteParcelado = true;
            }
            if (this.selecGuiasParctoTacito[i].pqtdparcelas > 59) {
              emitirParcelamentoSemAutorizacao = true;
            }
          }
          if (emitirParcelamentoSemAutorizacao) {
            this.carregando = false;
            this.mensagemErro.push(
              "Existe solicitação de parcelamento não autorizado !" +
                " Utilize a opção 'Emitir requerimento'" +
                " ou selecione um permitido ou clique em 'Limpar parcelamento'."
            );
            window.scrollTo(0, 0);
          } else {
            if (this.origemAcesso === "GovBr") {
              this.autenticarEmissao();
              this.finalizarEmissaoGuiaEmLista();
            } else {
              if (!this.somenteParcelado) {
                this.finalizarEmissaoGuiaEmLista();
              } else {
                this.abrirModal("modal-EmissaoGuia");
              }
            }
          }
        }
      }

      if (data.title === "fecharParcelamentosTacitos") {
        this.exibirFormaPagamento = true;
        this.bloqueiaOpcao = false;
        this.fecharGuiasParcelar();
      }
    },

    desabilitarCampos() {},

    habilitarCampos() {
      this.desabilitacodigoNacional = false;
      this.desabilitanomeContribuinte = false;
      this.desabilitaIdentificador = false;
      this.desabilitaParcelamento = false;
      this.bloquearExibirLancamentos = false;
    },

    limparMensagensDeErro() {
      this.mensagemErro = [];
      this.mensagemLancamentos = [];

      this.mensagemParcelamento = [];
      this.mostrarMensagemDebitosInexistentes = false;

      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoCPFCNPJ = "";

      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoIdentificador = "";

      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoParcelamento = "";

      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";

      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";

      this.erroValidacaoLancamento = "";
      this.mensagemValidacaoLancamento = "";
    },

    limparCamposParcelamento: function () {
      this.mensagemParcelamento = [];

      this.escolhaDemaisParcelamentos = "";
      this.mostrarDemais = false;

      this.escolhaCessao = "";
      this.mostrarCessao = false;

      this.informacaoParcelamento.email = "";
      this.informacaoParcelamento.telefone = "";
      this.bloquearExibirLancamentos = false;
    },

    abrirModal: function (referencia) {
      this.$refs[referencia].show();
    },

    formataParcelamentoTransacao: function (valor) {
      valor = valor + "";
      valor = parseInt(valor.replace(/[\D]+/g, ""));
      valor = valor + "";
      if (valor.length > 4) {
        valor = valor.replace(/([0-9]{4})$/g, "/$1");
      }
      if (valor == "NaN") {
        valor = "";
      }
      return valor;
    },

    formatarData: function (data) {
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0"); // Note que os meses começam do zero
      const ano = data.getFullYear();
      const horas = String(data.getHours()).padStart(2, "0");
      const minutos = String(data.getMinutes()).padStart(2, "0");
      const segundos = String(data.getSeconds()).padStart(2, "0");

      return `${dia}-${mes}-${ano} ${horas}:${minutos}:${segundos}`;
    },

    validacaoIndiceCadastral: function () {
      let erro = "";
      let textColor = "";

      // INDICE CADASTRAL
      this.mascaraIdentificador = {
        mask: "###.###E.###E.X##.J",
        tokens: this.tokens,
      };

      this.desabilitarCampos();
      this.erroValidacaoIdentificador = textColor;
      this.mensagemValidacaoIdentificador = erro;
    },

    validacaoIdentificador: function () {
      if (this.dadosContribuinte.tipoIdentificador === 1) {
        //inscrição municipal
        this.mascaraIdentificador = {
          mask: "#.###.###/###-J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 3) {
        // CPF
        this.mascaraIdentificador = {
          mask: "###.###.###-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 4) {
        // CNPJ
        this.mascaraIdentificador = {
          mask: "##.###.###/####-##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 5) {
        // PERPETUIDADE
        this.mascaraIdentificador = {
          mask: "##############",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 15) {
        // PROCESSO JUDICIAL
        this.mascaraIdentificador = {
          mask: "####################",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 14) {
        // PARCELAMENTO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 8) {
        // INDICE CADASTRAL
        this.mascaraIdentificador = {
          mask: "###.###E.###E.X##.J",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 10) {
        // PLACA DE VEICULO
        this.mascaraIdentificador = {
          mask: "LLL-#X##",
          tokens: this.tokens,
        };
      }

      if (this.dadosContribuinte.tipoIdentificador === 16) {
        // TRANSACAO
        this.mascaraIdentificador = {
          mask: "#######/####",
          tokens: this.tokens,
        };
      }
      this.desabilitarCampos();
    },

    validacaoParcelamento: function () {
      const anoAtual = new Date().getFullYear();
      const numeroParcelamento = this.dadosContribuinte.numeroParcelamento;
      const anoParcelamento = numeroParcelamento.substring(
        8,
        numeroParcelamento.length
      );

      let mensErro = "";
      let textColor = "";

      if (anoParcelamento > anoAtual) {
        mensErro =
          "O ano em que foi feito o parcelamento não pode ser maior que o ano atual";
        textColor = "text-danger";
      }

      this.desabilitarCampos();
      this.erroValidacaoParcelamento = textColor;
      this.mensagemValidacaoParcelamento = mensErro;
    },

    validacaoCPFCNPJ: function () {
      let mensErro = "";
      let textColor = "";

      if (this.dadosContribuinte.cadastroNacional.length > 0) {
        if (validarCpfCnpj(this.dadosContribuinte.cadastroNacional)) {
          textColor = "text-success";
          mensErro = "O CPF/CNPJ digitado é válido";
        } else if (this.dadosContribuinte.cadastroNacional.length > 0) {
          textColor = "text-danger";
          mensErro = "O CPF/CNPJ digitado não é valido";
        }
      }

      this.desabilitarCampos();
      this.erroValidacaoCPFCNPJ = textColor;
      this.mensagemValidacaoCPFCNPJ = mensErro;
    },

    validacaoCodigoParcelamento: function () {
      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";
    },

    validacaoPlacaVeiculo: function () {
      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoPlacaVeiculo = "";
    },

    validacaoLancamento: function () {
      this.erroValidacaoLancamento = "";
      this.mensagemValimparCampospesquisartlidacaoLancamento = "";
    },

    limparCampos: function () {
      this.limparMensagensDeErro();
      this.desabilitarAba("all");
      this.mostrarMensagemDebitosInexistentes = false;
      this.informacaoContribuinte.indiceCadastral = "";

      if (this.origemAcesso !== "GovBr") {
        this.dadosContribuinte.nomeContribuinte = "";
        this.dadosContribuinte.cpf = "";
        this.dadosContribuinte.cadastroNacional = "";
        this.dadosContribuinte.limparCamposcadastroNacional = "";
      }

      this.mostrarDemaisInformacoes = false;
      this.mostrarErroMuitosLancamentos = false;
      this.dadosContribuinte.razaoSocial = "";
      this.dadosContribuinte.tipoIdentificador = 0;
      this.dadosContribuinte.identificador = "";
      this.dadosContribuinte.numeroParcelamento = "";
      this.dadosContribuinte.placaVeiculo = "";
      this.dadosContribuinte.processoJudicial = "";
      this.dadosContribuinte.transacao = "";
      this.mostrarSelecaoDebitos = false;
      this.exibirDebitos = false;
      this.exibirListaGuia = false;
      this.exibeBotaoPesquisar = false;
      this.refazerAgrupamento = false;

      this.calculos = {
        OPCOES_PARCTO_CESSAO: [],
        OPCOES_PARCTO_DEMAIS: [],
        LANCAMENTO_CESSAO: [],
        LANCAMENTO_DEMAIS: [],
      };

      this.habilitarCampos();
    },

    abrirModalPagamentoAVistaSeNecessario: function (referencia) {
      if (this.calculos.TLISTAURLGUIA) this.$refs[referencia].show();
    },

    mostrarModalParcelamento: function () {
      if (
        this.calculos.OPCOES_PARCTO_CESSAO &&
        this.calculos.OPCOES_PARCTO_DEMAIS
      )
        this.$refs["modal-confirmar-parcelamento"].show();
      else {
        if (this.calculos.OPCOES_PARCTO_CESSAO)
          this.abrirModalParcelamentoSeNecessario("cessao");
        else this.abrirModalParcelamentoSeNecessario("demais");
      }
    },

    abrirModalParcelamentoSeNecessario: function (tipoLancamento) {
      this.fecharModal("dialog-confirmar-parcelamento");

      if (tipoLancamento === "cessao") {
        this.mostrarCessao = true;
        this.mostrarDemais = false;
        this.$refs["modal-parcelamento"].show();
      }

      if (tipoLancamento === "demais") {
        this.mostrarCessao = false;
        this.mostrarDemais = true;
        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirModalParcelamento: function (opcao) {
      this.opcaoParctoSelecionada = opcao;
      if (opcao.LISTA_OPCAO_PARCTO) {
        opcao.LISTA_OPCAO_PARCTO.map((calculo) => {
          this.listaOpcoesParcelamentoInternas.push({
            text: `Entrada de ${this.formatCurrency(
              calculo.AVLRDEPOSITOINICIAL
            )} + ${calculo.AQTDPARCELA} parcela(s) de ${this.formatCurrency(
              calculo.AVLRPARCELA
            )} (Desconto de ${calculo.APERCDEPOSITOINICIAL}%)`,
            value: calculo,
            disabled: false,
            hidden: false,
          });
        });

        this.listaDemaisParcelamentos.unshift({
          text: "Clique aqui para selecionar uma opção de parcelamento",
          value: "",
          selected: true,
          disabled: true,
          hidden: true,
        });

        this.$refs["modal-parcelamento"].show();
      }
    },

    abrirDialogPagamentoAVista() {
      /*if (
        this.lancamentosSelecionados.length !==
        this.orgaoCobranca[0].ALANCAMENTOS.length
      )
        this.$refs["dialog-confirmar-a-vista"].show();
      else*/
      this.abrirModalPagamentoAVistaSeNecessario("modal-pagamento-a-vista");
    },

    buscarCNPJSRelacionados: async function () {
      this.carregando = true;
      await this.$axios
        .get(
          `${this.$env.url_backend}${constantes.buscarCNPJRelacionados}?cpf=${this.$store.getters.userInfo.preferred_username}`
        )
        .then((response) => {
          response.data.cnpjRelacionados.listaEstabelecimento.map(
            (estabelecimento) => {
              this.cnpjsRelacionados.push(estabelecimento.cnpj);
            }
          );
          this.carregando = false;
        })
        .catch((error) => {
          const mensagem = normalizaMensagemApi(error);
          console.log(mensagem);
          this.carregando = false;
        });
    },

    abrirDialogParcelamento: async function () {
      const lancamentos = this.lancamentosSelecionados.map(
        (lancamento) => lancamento.ID_LANCAMENTO
      );

      await this.$axios
        .post(this.$env.url_backend + constantes.retornaOpcoesParcto, {
          lancamentosSelecionados: lancamentos,
        })
        .then((response) => {
          const retorno = response.data;
          const opcoesParctoRetorno = retorno[0];
          this.opcoesParcto = opcoesParctoRetorno;
        })
        .catch((error) => {
          this.carregando = false;
          window.scrollTo(0, 0);
          const mensagem = normalizaMensagemApi(error);
          this.mensagemParcelamento.push(mensagem);
        });

      if (this.opcoesParcto === null)
        this.mensagemParcelamento.push(
          "Não foram encontradas opções de parcelamento."
        );
      else this.$refs["modal-selecao-parcelamento"].show();
    },

    fecharModal: function (referencia) {
      this.$refs[referencia].hide();
    },

    retirarMensagensTela: function () {
      this.mensagemSucesso = [];
      this.mensagemErro = [];
      this.mensagemLancamentos = [];
      this.mensagemParcelamento = [];
      this.mensagemEmissaoGuia = [];
      this.mensagemEmissaoGuiaSucesso = [];

      this.mensagemValidacaoCPFCNPJ = "";
      this.erroValidacaoCPFCNPJ = "";
      this.mensagemValidacaoIdentificador = "";
      this.erroValidacaoIdentificador = "";
      this.mensagemValidacaoParcelamento = "";
      this.erroValidacaoParcelamento = "";
      this.mensagemValidacaoCodigoParcelamento = "";
      this.erroValidacaoCodigoParcelamento = "";
      this.mensagemValidacaoPlacaVeiculo = "";
      this.erroValidacaoPlacaVeiculo = "";
      this.mensagemValidacaoLancamento = "";
      this.erroValidacaoLancamento = "";
    },

    desabilitarAba(titulo) {
      if (titulo === "all") {
        this.mostrarSelecaoDebitos = false;
        this.mostrarSelecaoDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirDebitos = false;
        this.verLancamentos = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }

      if (titulo === "selecaoDebito") {
        this.mostrarSelecaoDebitos = false;
        this.mostrarSelecaoDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirDebitos = false;
        this.verLancamentos = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "selecaoLancamento") {
        this.limparSelecao = true;
        this.mostrarSelecaoDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirDebitos = false;
        this.verLancamentos = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "debitos") {
        this.exibirDebitos = false;
        this.exibirFormaPagamento = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirListaGuia = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "formaPagamento") {
        this.exibirFormaPagamento = false;
        this.exibirListaGuia = false;
        this.exibirListaGuiaParcelar = false;
        this.exibirParcelamento = false;
      }
      if (titulo === "opcoesParcelamento") {
        this.exibirListaGuiaParcelar = false;
        this.exibirParcelamento = false;
      }
    },

    selecionarNovosLanctos() {
      this.refazerAgrupamento = false;
      this.bloqueiaOpcao = false;
      this.habilitaSelecaoDebitos();
    },

    habilitaSelecaoDebitos() {
      this.mensagemErroFormaPagto = [];

      this.desabilitarAba("selecaoLancamento");
      this.exibirDebitos = true;
      this.mostrarSelecaoDebitos = false;
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
      this.reinicializarSelecao = false;
    },

    fecharGuiasParcelar() {
      this.exibirListaGuiaParcelar = false;
      this.opcaoParcelaSelecionada = null;
    },

    pagarVista() {
      this.mensagemErroFormaPagto = [];
      this.exibirListaGuia = false;
      this.exibirListaGuiaParcelar = false;
      this.exibirFormaPagamento = false;
      this.retornaCalculos();
    },

    fecharGuiasAVista() {
      this.exibirListaGuia = false;
      this.exibirFormaPagamento = true;
    },

    parcelar() {
      if (this.permiteParcelar) {
        this.exibirListaGuiaParcelar = false;
        this.exibirListaGuia = false;
        this.exibirFormaPagamento = false;
        this.retornaCalculosParcelar();
      } else {
        this.mensagemErroFormaPagto = [];
        this.mensagemErroFormaPagto.push(
          "Existe(m) débito(s) selecionado(s) que não permite(m) parcelar."
        );
        this.carregando = false;
      }
    },

    selecionaOpcaoGuiaParcelado(valor) {
      this.habilitaBotaoSelecionarGuia = valor === null;
    },

    guiaPagamentoParcelado(idx) {
      const ind = this.btnSelecionados.findIndex((e) => e.id === idx);

      // se já foi clicado ( existe na lista), remove
      if (ind !== -1) {
        this.btnSelecionados = this.btnSelecionados.filter(
          (item) => item.id != idx
        );
      } // inclui ( clicado )
      else {
        this.btnSelecionados.push({ id: idx });
      }
    },

    retornaSelecaoDebitos() {
      this.novaPesquisa = "N";
      this.reinicializarSelecao = true;
      this.orgaoCobranca = [];
      this.refazerAgrupamento = true;
      this.mostrarSelecaoDebitos = true;
      this.exibirDebitos = false;
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
    },

    mostrarDebitosSelecionados() {
      this.exibirFormaPagamento = false;
      this.verLancamentos = false;
      this.exibirDebitosSelecionados = true;
    },

    fecharDebitosSelecionados() {
      this.exibirDebitosSelecionados = false;
      this.exibirFormaPagamento = true;
      this.verLancamentos = true;
    },

    onClose() {
      this.popoverShow = false;
    },
    onOk() {
      this.onClose();
      this.exibirFormaPagamento = true;
      this.verLancamentos = true;
      this.exibirDebitos = false;
      this.debitosSelecionados = this.lancamentosSelecionados;
      if (!this.permiteParcelar) {
        this.mensagemErroFormaPagto = [];
        this.mensagemErroFormaPagto.push(
          "Identificamos que foram selecionados débitos que não permitem parcelamento. Diante disso, a opção disponível é apenas para pagamento integral ou parcial. Caso a seleção não esteja correta, você pode refazer a seleção dos débitos acionando o botão < Selecionar novos débitos >."
        );
        this.carregando = false;
      }
    },

    montaAgrupamento: function (lista) {
      let agrupamentos = [];
      lista.map(function (lancamento) {
        agrupamentos.push({
          nome: lancamento.DESCRICAO,
          tooltip: lancamento.TOOLTIP,
          selecionado: false,
          valor: lancamento.VALOR || null,
          subitems:
            lancamento.LISTA_NIVEL2?.map(function (subnivel) {
              return {
                valor: `${lancamento.DESCRICAO}.${subnivel.DESCRICAO}`,
                selecionado: false,
                ALANCAMENTOS: subnivel.ALANCAMENTOS,
                qtdlanctos: subnivel.AQTDLANCTOS,
                valoravista: subnivel.AVALORAVISTA,
                valordebito: subnivel.AVALORDEBITO,
                valordesconto: subnivel.AVALORDESCONTO,
                nome: subnivel.DESCRICAO,
                aTooltip: subnivel.ATOOLTIP,
              };
            }) || null,
        });
      });
      return agrupamentos;
    },

    limparmensagemValidacao: function () {
      if (
        this.informacaoContribuinte.indiceCadastral == "" ||
        this.informacaoContribuinte.indiceCadastral == null
      ) {
        this.mensagemValidacaoIptu = "";
      }
    },

    validarInscricaoMunicipal: function (inscricaoMunicipal) {
      inscricaoMunicipal = inscricaoMunicipal.replace(/[^\dxX]+/g, "");

      const sequencial = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      let identificadorSemDigitoVerificador = "";
      let soma = 0;
      if (inscricaoMunicipal.length < 10)
        identificadorSemDigitoVerificador = inscricaoMunicipal
          .substring(0, 9)
          .padStart(10, "0");
      else if (inscricaoMunicipal.length === 10)
        if (inscricaoMunicipal.substring(0, 1) === "0")
          identificadorSemDigitoVerificador = inscricaoMunicipal
            .substring(1, 9)
            .padStart(10, "0");
        else if (Number(inscricaoMunicipal.substring(11, 1)))
          identificadorSemDigitoVerificador = inscricaoMunicipal;
        else
          identificadorSemDigitoVerificador = inscricaoMunicipal
            .substring(0, 9)
            .padStart(10, "0");
      else
        identificadorSemDigitoVerificador = inscricaoMunicipal
          .padStart(11, "0")
          .substring(0, 10);
      for (let i = 0; i < identificadorSemDigitoVerificador.length; i++)
        soma += Number(identificadorSemDigitoVerificador[i] * sequencial[i]);

      let resto = soma % 11;

      inscricaoMunicipal = inscricaoMunicipal.padStart(10, "0");

      const digitoVerificador =
        resto === 0 ? "0" : resto === 1 ? "X" : 11 - resto;
      identificadorSemDigitoVerificador += digitoVerificador;
      return inscricaoMunicipal === identificadorSemDigitoVerificador;
    },

    preencheIPTU: function () {
      let tam = 0;
      let mensIPTU = "";
      let textColor = "";
      let opcao = "";

      this.mensagemValidacaoIPTU = "";

      if (this.informacaoContribuinte.indiceCadastral.length > 0) {
        //INDICE CADASTRAL
        tam = 19;
        opcao = "ÍNDICE CADASTRAL";

        mensIPTU =
          this.informacaoContribuinte.indiceCadastral.length >= tam
            ? opcao + " digitado é válido"
            : opcao + " digitado está incompleto";

        textColor =
          this.informacaoContribuinte.indiceCadastral.length >= tam
            ? "text-success"
            : "text-danger";
        this.preencheIptuOK =
          this.informacaoContribuinte.indiceCadastral.length >= tam;
        if (this.informacaoContribuinte.indiceCadastral.length >= tam) {
          // indice cadastral
          if (validarIPTU(this.informacaoContribuinte.indiceCadastral)) {
            mensIPTU = opcao + " digitado(a) é válido(a)";
            textColor = "text-success";
            this.preencheIptuOK = true;
          } else {
            mensIPTU = opcao + " - dígito verificador inválido";
            textColor = "text-danger";
            this.preencheIptuOK = false;
          }
        }

        this.desabilitarCampos();

        this.erroValidacaoIptu = textColor;
        this.mensagemValidacaoIptu = mensIPTU;
      }
    },

    montaAgrupamentoParcto: function (lista, idLancamentos) {
      //let urls = this.listaUrlsGuias;
      let agrupamentos = [];
      lista.map(function (lancamento) {
        agrupamentos.push({
          descricao_grupo: lancamento.DESCRICAO_GRUPO,
          lista_lancamento: idLancamentos,
          lista_lancamento_agrupamento: lancamento.LISTA_LANCAMENTO,
          selecionado: null,
          urlGuia: null,
          urlRelatorio: null,
          emitido: false,
          lista_opcao_parcto:
            lancamento.LISTA_OPCAO_PARCTO?.map(function (subnivel) {
              return {
                APercDepositoInicial: subnivel.APERCDEPOSITOINICIAL,
                AVlrDepositoInicial: subnivel.AVLRDEPOSITOINICIAL,
                AQtdParcela: subnivel.AQTDPARCELA,
                AQtdParcelaHonorario: subnivel.AQTDPARCELAHONORARIO,
                AVlrParcela: subnivel.AVLRPARCELA,
                AVlrParcelaHonorario: subnivel.AVLRPARCELAHONORARIO,
                AVlrdesconto: subnivel.AVLRDESCONTO,
                AIdTipoParcelamento: subnivel.AIDTIPOPARCELAMENTO,
                AIdRegraParcelamento: subnivel.AIDREGRAPARCELAMENTO,
                AIdFaixasRegraParcelamento: subnivel.AIDFAIXASREGRAPARCELAMENTO,
                adescricao: subnivel.ADESCRICAO,
              };
            }) || null,
        });
      });
      return agrupamentos;
    },

    toggleAll(checked) {
      this.selected = checked ? this.orgaoCobranca.slice() : [];
    },
  },

  watch: {
    "informacaoContribuinte.indiceCadastral"(newValue) {
      this.limparmensagemValidacao();
      if (newValue.length > 0) {
        this.preencheIPTU();
      } else {
        this.preencheIptuOK = false;
      }
    },

    selected(newValue) {
      // Handle changes in individual flavour checkboxes
      if (newValue.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newValue.length === this.orgaoCobranca.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },

  computed: {
    rows() {
      return this.items.length;
    },
  },

  async beforeMount() {
    this.userName = this.$store.getters.userInfo.preferred_username;
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.origemNome = this.$store.getters.userInfo.name;
    if (this.origemAcesso === "GovBr") {
      this.dadosContribuinte.cadastroNacional = this.userName;
      this.dadosContribuinte.nomeContribuinte = this.origemNome.toUpperCase();
      await this.buscarCNPJSRelacionados();
    }
  },

  created() {
    this.cabecalhoLancamento = this.cabecalhoLancamento.map((atributo) => {
      return {
        key: atributo.key,
        label: atributo.label,
        formatter: atributo.formatter,
        sortable: atributo.sindiceCadastralimportortable,
      };
    });

    this.cabecalhoEmissaoGuia = this.cabecalhoEmissaoGuia.map((atributo) => {
      return {
        key: atributo.key,
        label: atributo.label,
        formatter: atributo.formatter,
        sortable: atributo.sortable,
      };
    });
  },

  async mounted() {
    ///  verifica se existe um periodo de interrupção da alteração de IPTU
    this.exibirSomenteAviso = false;
    await this.$axios
      .post(
        this.$env.url_backend + constantes.retornaPeriodoInterrupcaoAltEndIPTU,
        {}
      )
      .then((response) => {
        const retorno = response.data;
        const interrompeServico = retorno.INTERRUPCAO_CADASTRO_ALT_END_IPTU;   
        const inicioPeriodoInterrupcao = retorno.INICIO_INTERRUPCAO_ALT_END_IPTU;
        const fimPeriodoInterrupcao = retorno.FIM_INTERRUPCAO_ALT_END_IPTU;    
        this.periodoInterrupcao = inicioPeriodoInterrupcao + ' A ' + fimPeriodoInterrupcao;
        this.exibirSomenteAviso = interrompeServico === 'S' ? true : false; 
        const dataFim =  moment(fimPeriodoInterrupcao,"DD/MM/YYYY");
        this.anoIPTU = dataFim.year();
        this.dataLiberadaInterrupcao = dataFim.add(1,"day").format("DD/MM/YYYY");
      })

      .catch((err) => {
        const mensagem = normalizaMensagemApi(err);
        this.mensagemParcelamento.push(mensagem);
        window.scrollTo(0, 0);
      });
    
    this.handleCarregaTiposIdentificadores();
  },
};
</script>

<style lang="css" scoped>
.container {
  min-width: 90%;
  max-width: 90%;
}

::v-deep .small-modal .modal-dialog {
  width: 30%;
  max-width: 50%;
}

::v-deep .modal-dialog {
  width: 95%;
  max-width: 100%;
}

hr {
  border-color: #aaa;
  box-sizing: border-box;
  width: 100%;
}

.botao {
  width: 150px;
  height: 80px;
}

.tooltip .tooltiptext {
  width: 20px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.inner-btn {
  position: absolute;
  width: 10px;
  font-weight: 550;
  border: none;
  background-color: transparent;
  line-height: 35px;
  left: calc(100% - 30px);
  z-index: 99999;
}

.inner-btn:hover {
  color: blue;
}
</style>
